import { MD5 } from "crypto-js";
import * as Scroll from "react-scroll";
import bankBABO from "./../assets/images/png/bankBABO.png";
import bankCITI from "./../assets/images/png/bankCITI.png";
import bankHDFC from "./../assets/images/png/bankHDFC.png";
import bankICIC from "./../assets/images/png/bankICIC.png";
import bankPUNB from "./../assets/images/png/bankPUNB.png";
import bankSBIN from "./../assets/images/png/bankSBIN.png";
import nsdllogo from "./../assets/images/svg/nsdllogo.svg";
import cdsllogo from "./../assets/images/svg/cdsllogo.svg";
import bankDefault from "./../assets/images/png/bankDefault.png";
import { amcList } from "./amcList";
import { bankList } from "./bankList";
import {
  newMonthData,
  monthsNum,
  monthsData3,
  //derivativeFixTab,
  derivativeTabs,
} from "./data";
import excel from "exceljs";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import AuthStore from "../store/AuthStore";
import UserStore from "../store/UserStore";
import SettingsStore from "../store/SettingsStore";
import ReportsStore from "../store/ReportsStore";
import AnalyticsStore from "../store/AnalyticsStore";
import PerformanceStore from "../store/PerformanceStore";
import ProfileStore from "../store/ProfileStore";
import ProfileStore2 from "../store/ProfileStore2";
import { getCookie, getAllCookies, deleteCookie } from "./cookie";
import { clearTable } from "./indexedDB";
import * as Sentry from "@sentry/react";
//import moengage from "@moengage/web-sdk";
import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import {
  allExcelClms,
  aquisitionValue,
  COMBINED,
  currencySymbols,
  excelClmReference,
  excelPdfDisclaimerLink,
  goldenFill,
  headerFill,
  headerFont,
  OFFSHORE,
  offshoreAssetClassSheetName,
  offshoreValues,
  monthMap,
  ttRedColorArr,
  UGLReportName,
  homePageRoute,
} from "./constants";
import OverflowingText from "../components/OverflowingText/OverflowingText";
// import moengage from "@moengage/web-sdk";

import qtybag from "./../assets/images/svg/qtybag.svg";
import getSymbolFromCurrency from "currency-symbol-map";
import { generateTransactionsReport } from "./createPdfFile";

const monthsData = [
  "a",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const getMonthStr = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const getMonthNum = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: 10,
  Nov: 11,
  Dec: 12,
};

export const countAlphabets = (str) => {
  // Regular expression to match alphabetic characters
  const matches = str.match(/[a-zA-Z]/g);
  // If there are matches, return the length of the array, otherwise return 0
  return matches ? matches.length : 0;
};

export const countNumbers = (str) => {
  // Regular expression to match numeric digits
  const matches = str.match(/\d/g);
  // If there are matches, return the length of the array, otherwise return 0
  return matches ? matches.length : 0;
};

export const countAlphabetNum = (str) => {
  return {
    num: countNumbers(str),
    alphabet: countAlphabets(str),
  };
};

export const isCustomDate = (str) => {
  const { num, alphabet } = countAlphabetNum(str);
  return str.length === 25 && num === 12 && alphabet === 6 ? true : false;
};

export const getDateString = (data) => {
  const { year, month, date } = data;
  return `${date}-${month}-${year}`;
};

export const getDateStrPerformance = (data) => {
  const { year, month, date } = data;
  return `${year}-${month}-${date}`;
};

export const getAssetClasses = (options) => {
  switch (String(options)) {
    case "2":
      return "Equity";
    case "3":
      return "Hybrid/Multi Asset";
    case "4":
      return "Fixed Income";
    case "5":
      return "Alternatives";
    case "6":
      return "DERIVATIVES";

    case "0":
      return "Cash";

    default:
      return "Default";
  }
};

export const getPerformance = ({ route }) => {
  switch (route) {
    case "1":
      return "Futures ";
      break;
    case "0":
      return "Options ";
      break;
    default:
      return "";
      break;
  }
};

export const getSubAssetClasses = (options) => {
  switch (String(options)) {
    case "2": //1
      return "Alternatives - Others";
    case "7": //2
      return "BONDS (TAX FREE)";
    case "13": //3
      return "Debt - Others";
    case "14": //4
      return "Debt-PMS";
    case "15": //5
      return "Direct Equity/Stocks";
    case "16": //6
      return "Equity Derivatives";
    case "17": //7
      return "Equity-Others"; //
    case "18": //8
      return "Equity-PMS";
    case "36": //9
      return "Structured Products - Debt";
    case "38": //10
      return "Structured Products - Equity";
    case "51": //11
      return "Mutual Funds - Hybrid";
    case "52": //12
      return "BONDS (TAXABLE)";
    case "53": //13
      return "Alternatives - Mutual Funds";
    case "54": //14
      return "Alternatives - Debt";
    case "55": //15
      return "Equity - AIF";
    case "56": //16
      return "DYB (Dividend)";
    case "57": //17
      return "Mutual Funds - Debt";
    case "58": //18
      return "Mutual Funds - Equity";
    case "59": //19
      return "LIF (Bonus)";
    case "60": //20
      return "Mutual Funds - Liquid";
    case "61": //21
      return "Debt - Deposits";
    case "62": //22
      return "Alternatives - Commodity";
    case "63": //23
      return "Alternatives - Real Estate";
    case "64": //24
      return "Equity";
    case "65": //25
      return "ARE (Dividend)";
    case "66": //26
      return "Debt - AIF";
    case "67": //27
      return "(Dividend)";
    case "68": //28
      return "(Growth)";
    case "69": //29
      return "Equity - Others";
    case "70": //30
      return "Alternatives - Art";
    case "72": //31
      return "Debt - Money Market Insruments";
    case "75": //32
      return "CRF (Dividend)";
    case "76": //33
      return "Alternatives - Equity";
    case "78": //34
      return "CPF (Growth)";
    case "79": //35
      return "Multi - Asset PMS";
    case "80": //36
      return "ARE (Growth)";
    case "81": //37
      return "Bonds";
    case "82": //38
      return "CPF (Dividend)";
    case "83": //39
      return "INVIT/REIT";
    case "85": //40
      return "Others(Managed)-AIF-Alternatives";
    case "88": //41
      return "Equity - AIF";
    case "90": //42
      return "EQ (Dividend)";
    case "91": //43
      return "EQ (Growth)";
    case "93": //44
      return "Alternatives - PMS";
    case "94": //45
      return "Cumulative Coupon Bond";
    case "95": //46
      return "Insurance";
    default:
      return "Default";
  }
};

export const getMonthStrPerformance = {
  "00": "January",
  "01": "February",
  "02": "March",
  "03": "April",
  "04": "May",
  "05": "June",
  "06": "July",
  "07": "August",
  "08": "September",
  "09": "October",
  10: "November",
  11: "December",
};

export const pad0 = (data) => {
  return data.toString().padStart(2, "0");
};

export const getDoubleDigit = (data) => {
  if (data) {
    return data < 10 ? `0${data}`?.replaceAll("00", "0") : data;
  } else {
    return "01";
  }
};

export const getCalenderDate = (date) => {
  return `${
    date?.date < 10 ? `0${date?.date}`?.replaceAll("00", "0") : date?.date
  } ${monthsData3[monthsNum.indexOf(date?.month)]} ${date?.year} `;
};

export const getDateFrmStr = (dateArr) => {
  const dates = dateArr?.split(" ");
  return {
    date: dates?.[0],
    month: String(getDoubleDigit(monthsData3.indexOf(dates?.[1]) + 1)),
    year: dates?.[2],
  };
};

export const capitaliseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const isShowData = (amt, sanctionedAmt) => {
  if (
    (amt && Number(amt) !== 0) ||
    (sanctionedAmt && Number(sanctionedAmt) !== 0)
  ) {
    return true;
  } else {
    return false;
  }
};

export const getLas = (data) => {
  let newData = data;
  let data2 = newData?.monthlybreakupList?.map((eachData) => {
    return {
      ...eachData,
      month: getMonthforLiab[eachData.month],
    };
  });

  let changedData = {
    ...newData,
    monthlybreakupList: data2,
  };
  return changedData;
};

export const getMonthforLiab = {
  January: "1",
  February: "2",
  March: "3",
  April: "4",
  May: "5",
  June: "6",
  July: "7",
  August: "8",
  September: "9",
  October: "10",
  November: "11",
  December: "12",
};

export const getMonthforLiabShow = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

const monthsData2 = [
  "0",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const monthFullNameArr = [
  "0",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const getDatesObj = (dateArr) => {
  const dateObj = new Date(dateArr[0], Number(dateArr[1]) - 1);
  const newobj = {
    startDay: dateObj.getDay(),
    prevMonthEndDate: new Date(
      dateObj.getFullYear(),
      dateObj.getMonth(),
      0,
    ).getDate(),
    thisMonthEndDate: new Date(
      dateObj.getFullYear(),
      dateObj.getMonth() + 1,
      0,
    ).getDate(),
  };

  return newobj;
};

export const calenderSetter = (
  changedDate,
  compareWithDate,
  forFromLimitDate,
  minDate,
  selectedFromDate,
  DateType,
  setFromCalender,
  setToCalender,
) => {
  const getTime = (date) => {
    return new Date(date).getTime();
  };

  const changedDateTime = getTime(changedDate);
  const toDateTime = getTime(compareWithDate);
  const asOfDateTime = getTime(forFromLimitDate);
  const minDateTime = getTime(minDate);
  const fromDateTime = getTime(
    String(selectedFromDate.year) +
      "-" +
      `${
        monthFullNameArr.indexOf(selectedFromDate.month) < 10
          ? "0" + monthFullNameArr.indexOf(selectedFromDate.month)
          : monthFullNameArr.indexOf(selectedFromDate.month)
      }` +
      "-" +
      String(
        `${
          selectedFromDate.date < 10 && selectedFromDate.date?.length === 1
            ? "0" + selectedFromDate.date
            : selectedFromDate.date
        }`,
      ),
  );

  const changeArr = changedDate?.split("-");
  const minArr = minDate?.split("-");
  const maxArr = forFromLimitDate?.split("-");

  if (DateType === "to") {
    if (changedDateTime < fromDateTime) {
      if (changedDateTime < minDateTime) {
        setFromCalender(minDate, minArr);
        setToCalender(minDate, minArr);
        // here change both the dates to minDate
      } else {
        setFromCalender(changedDate, changeArr);
        setToCalender(changedDate, changeArr);
        // change both the dates to newDate
      }
    } else if (changedDateTime > asOfDateTime) {
      // change to date to as of date
      setToCalender(forFromLimitDate, maxArr);
    } else {
      setToCalender(changedDate, changeArr);
      // change to date to new date
    }
  } else {
    if (changedDateTime > toDateTime) {
      if (changedDateTime > asOfDateTime) {
        setFromCalender(forFromLimitDate, maxArr);
        setToCalender(forFromLimitDate, maxArr);
        // change both dates to as of date
      } else {
        setFromCalender(changedDate, changeArr);
        setToCalender(changedDate, changeArr);
        //change both the dates to new date
      }
    } else if (changedDateTime < minDateTime) {
      setFromCalender(minDate, minArr);
      // change from date to min date
    } else {
      if (toDateTime > asOfDateTime) {
        setFromCalender(changedDate, changeArr);
        setToCalender(changedDate, changeArr);
      }
      setFromCalender(changedDate, changeArr);
      // change from to new date
    }
  }
};

export const isValueExist = ({ value, value2, defaultValue }) => {
  if (value) {
    return value;
  } else {
    return value2 || defaultValue;
  }
};

export const trackEvent = (eventName) => {
  //  false && moengage.track_event(eventName);
};

export const trackEventWithScreen = ({ eventName, screenName }) => {
  // false &&
  //   moengage.track_event(eventName, {
  //     Screen_Name: screenName,
  //   });
};

export const logEvents = (eventName, attributes) => {
  // if (false) {
  const { user_type } = getDecodedToken();
  const analytics = getAnalytics();
  const buildData =
    process.env.REACT_APP_MEASUREMENT_ID_ANALYTICS === "G-Y5WNK9ELH8"
      ? {
          users_type: user_type,
        }
      : {
          users_type: user_type,
          environment:
            process.env.REACT_APP_MEASUREMENT_ID_ANALYTICS === "G-ZKZGHWXFMX"
              ? "UAT"
              : "staging",
        };
  !attributes
    ? logEvent(analytics, eventName)
    : logEvent(analytics, eventName, {
        ...attributes,
        ...buildData,
      });
  // }
};

export const setGAProperties = (properties) => {
  // if (false) {
  const analytics = getAnalytics();
  setUserProperties(analytics, properties);
  // }
};

export const setDerivativeTabKeys = (index) => {
  switch (index) {
    case 0:
      return "ITD";
    case 1:
      return "YTD";
    case 2:
      return "FY-1";
    case 3:
      return "FY-2";
    case 4:
      return "FY-3";
    case 5:
      return "-";
    case 6:
      return "-";
    default:
      return "ITD";
  }
};

export const getDuraion = (data, id) => {
  // const isTabPresent = derivativeFixTab.includes(data);

  if (id === 6) {
    if (derivativeTabs.includes(data)) {
      return data;
    } else if (PerformanceStore.subTabs?.includes(data)) {
      // send According to index
      return derivativeTabs[PerformanceStore.subTabs?.indexOf(data)];
    } else return "ITD";
  } else {
    if (PerformanceStore.subTabs?.includes(data)) {
      return data;
    } else if (derivativeTabs.includes(data)) {
      // send According to index
      return PerformanceStore.subTabs?.[derivativeTabs.indexOf(data)];
    } else return data;
  }

  // if (
  //   !derivativeTabs.includes(data) &&
  //   !PerformanceStore.subTabs?.includes(data)
  // ) {
  //   return data;
  // } else if (id !== 6 && isTabPresent) {
  //   return PerformanceStore.subTabs?.[derivativeTabs.indexOf(data)];
  // } else if (id === 6 && !isTabPresent) {
  //   return derivativeTabs[PerformanceStore.subTabs?.indexOf(data)];
  // } else {
  //   return data;
  // }
  //return id!==6 && derivativeFixTab.includes(data) ?  PerformanceStore.subTabs?.[derivativeTabs.indexOf(data)] : id!==6 && !derivativeFixTab.includes(data)
};

export const getAssetInternalTabs = (arr, key) => {
  return arr?.map((data) => data[key]);
};

export const getMonthForQuarter = (month) => {
  return month >= 1 && month <= 3
    ? "00"
    : month >= 4 && month <= 6
      ? "03"
      : month >= 7 && month <= 9
        ? "06"
        : month >= 10 && month <= 12
          ? "09"
          : "";
};

export const getDateForSort = (date) => {
  // date format here is "mm/dd/yyyy time"
  const splitDate = date?.split(" ");
  const dArray = splitDate?.[0].split("/");
  return dArray[2].concat(dArray[0], dArray[1]);
};

export const getDateForSortInst = (date) => {
  // date format here is "mm/dd/yyyy time"

  const dArray = date?.split("-");
  return dArray[0].concat(dArray[1], dArray[2]);
};

export const getDateUnrealied = (date) => {
  // date format here is "dd/mm/yyyy time"
  const dArray = date?.split("/");
  return dArray[2].concat(dArray[1], dArray[0]);
};

export const getDateInNum = (date) => {
  const newDateArray = date?.split(" ");
  const monthNum = monthsData2.indexOf(newDateArray[1]);
  return `${newDateArray[2]}-${monthNum < 10 ? "0" + monthNum : monthNum}-${
    newDateArray[0]
  }`;
};

export const get1stDate = (data) => {
  const month = data.getMonth() + 1;
  return `${data.getFullYear()}-${month < 10 ? "0" + month : month}`;
};

export const getMonth = (monthNumber) => {
  const month = monthNumber + 1;
  return month < 10 ? `0${month}` : month;
};

export const getSecond = (seconds) => {
  return seconds < 10 ? `0${seconds}` : seconds;
};

export const getCurrentTime = () => {
  const newTime = new Date();
  return (
    `${newTime.getHours()}` +
    ":" +
    `${newTime.getMinutes()}:${getSecond(newTime.getSeconds())}`
  );
};

export const getAddition = (num1, num2) => {
  const Num1 = !isNaN(num1) ? Number(num1) : 0;
  const Num2 = !isNaN(num2) ? Number(num2) : 0;

  return Num1 + Num2;
};

export const getExcelPdfName = (report, member, account, isFam, clientName) => {
  return member?.includes("All")
    ? `${report} ${UserStore.userData?.family_name}`
    : account === "All" && member.length === 1
      ? `${report}  ${member?.[0]?.full_name}`
      : account === "All" && member.length > 1
        ? `${report ? report?.replaceAll(" -", "") : ""}`
        : `${report}  ${account?.account_Name}`;
};

export const getExcelPdfNamePortfolio = (
  report,
  member,
  account,
  isFam,
  clientName,
) => {
  return typeof member === "string" && member?.includes("All")
    ? `${report}_${UserStore.userData?.family_name}`
    : account === "All"
      ? `${report}_${member?.full_name}`
      : `${report}_${account?.account_Name}`;
};

export const getNameForPortfolioReportExcel = (member, account) => {
  return typeof member === "string" && member?.includes("All")
    ? UserStore.userData?.family_name
    : account === "All"
      ? member?.full_name
      : account?.account_Name;
};

export const getExcelPdfName2 = (report, member) => {
  return member === "All"
    ? `${report} ${UserStore.userData?.family_name}`
    : member.length > 1
      ? `${report ? report?.replaceAll(" -", "") : ""}`
      : `${report} ${member?.[0]?.full_name}`;
};

export const unrealisedName = (member, account) => {
  return account === "All" ? member?.full_name : account?.account_Name;
};

export const getSortedData = (data) => {
  for (let i = data?.length; i > 0; i--) {
    for (let j = 0; j < i; j++) {
      for (let k = 0; k < data?.[j]?.amc_manufacturer?.length; k++) {
        let a = data?.[j]?.amc_manufacturer?.charCodeAt(k);
        let b = data?.[j + 1]?.amc_manufacturer?.charCodeAt(k);
        let temp = null;

        if (a > b && a - b !== 32) {
          temp = data?.[j];
          data[j] = data?.[j + 1];
          data[j + 1] = temp;
          break;
        } else if (a < b && a - b !== 32) {
          break;
        }
      }
    }
  }

  return data;
};

export const returnModifiedData = (vehicle) => {
  return {
    data_Par_Value: vehicle.par_value_amt.actual_value || "-",
    data_Principle_Amt: vehicle.principal_paid_amt?.actual_value || "-",
    data_Curr_Value:
      vehicle.investmentreturn?.current_value.actual_value || "-",
    data_Inv_Value:
      vehicle.investmentreturn?.invested_value.actual_value || "-",
    data_Int_Div: vehicle?.interest_others_amt?.actual_value || "-",
    data_Unre_Gain:
      vehicle.investmentreturn?.unrealised_gain?.amount.actual_value || "-",
    data_Real_Gai:
      vehicle.investmentreturn?.realised_gain.amount.actual_value || "-",
    data_Total_Gai:
      vehicle.investmentreturn?.total_returns?.actual_value || "-",

    par_value: vehicle.par_value_amt.value || "-",
    par_unit: vehicle.par_value_amt.value_type,
    principal_paid_amt: vehicle.principal_paid_amt?.value || "",
    pp_unit: vehicle.principal_paid_amt?.value_type,
    actualWholeObject: vehicle,
    instrument_name: vehicle.instrument?.name,
    qty: vehicle.units,
    Avg_buy_price:
      vehicle.average_buy_price && !isNaN(vehicle.average_buy_price)
        ? Number(vehicle.average_buy_price)?.toFixed(2)?.toLocaleString("hi-IN")
        : vehicle.average_buy_price,
    cmp:
      vehicle.cmp && !isNaN(vehicle.cmp)
        ? Number(vehicle.cmp)?.toFixed(2)?.toLocaleString("hi-IN")
        : vehicle.cmp,
    current_value: {
      subtext: vehicle.investmentreturn?.as_of_date,
      text: `${vehicle.investmentreturn?.current_value.value || "-"}`,
      textUnit: vehicle.investmentreturn?.current_value.value_type,
    },
    inv_value: `${vehicle.investmentreturn?.invested_value.value || "-"}`,
    invUnit: vehicle.investmentreturn?.invested_value.value_type,
    int_div_others: `${vehicle.interest_others_amt.value || "-"}`,
    intDivUnit: vehicle.interest_others_amt.value_type,
    unrealised_gain: {
      subtext: vehicle.investmentreturn?.unrealised_gain?.percentage,
      text: `${vehicle.investmentreturn?.unrealised_gain?.amount.value || "-"}`,
      textUnit: vehicle.investmentreturn?.unrealised_gain?.amount.value_type,
    },
    unrealised_percentage:
      vehicle.investmentreturn?.unrealised_gain?.percentage,

    realised_Gains: `${
      vehicle.investmentreturn?.realised_gain.amount.value || "-"
    }`,
    realisedUnit: vehicle.investmentreturn?.realised_gain.amount.value_type,
    as_on_date: vehicle.investmentreturn.as_of_date,
    total_gains: {
      text: `${vehicle.investmentreturn?.total_returns?.actual_value || "-"}`,
      textUnit: vehicle.investmentreturn?.total_returns?.value_type,
    },
    irr: vehicle.investmentreturn.irr,
    id: vehicle.instrument.id,
    instrumentId: vehicle.instrument.id,
    measure_instr_id: vehicle.instrument.measureinstrumentid,
    isUnitBased: vehicle.instrument.isUnitBased,
    isInterest: vehicle.instrument.isInterest,
  };
};

export const getFirstProfile = (data) => {
  let sentData = data;
  let primaryIndex = null;
  const primaryData = data?.filter((eachData, index) => {
    if (eachData?.isprimary === true) {
      primaryIndex = index;
      return eachData?.isprimary === true;
    } else return false;
  });

  sentData?.splice(primaryIndex, 1);
  sentData?.push(primaryData);

  return sentData ? sentData : [];
};

export const commaSeperated = (numData) => {
  if (String(Number(numData))?.includes("."))
    return Number(numData)
      .toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      })
      .replace("₹", "");
  else return Number(Number(numData)?.toFixed(2))?.toLocaleString("hi-IN");
};

export const commaSeperated2 = (numData) => {
  const newNum = numData?.replaceAll(",", "");

  if (String(Number(newNum))?.includes(".")) {
    return Number(newNum)
      .toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      })
      .replace("₹", "");
  } else return Number(Number(newNum)?.toFixed(2))?.toLocaleString("hi-IN");
};

export const getLimitPer = (data) => {
  const newAmt = Number(data);

  return newAmt > 9999.9
    ? ">9,999.99"
    : newAmt < -9999.9
      ? "<-9,999.99"
      : commaSeperated(data);
};

export const getLimitPerExcel = (data) => {
  const newAmt = Number(data);

  return newAmt
    ? newAmt > 9999.9
      ? ">9,999.99"
      : newAmt < -9999.9
        ? "<-9,999.99"
        : newAmt
    : "-";
};

export const getLimitPerExcelPerf = (data) => {
  const newAmt = Number(data);

  return newAmt > 9999.9
    ? ">9,999.99"
    : newAmt < -9999.9
      ? "<-9,999.99"
      : newAmt;
};

export const showDashIfZero = (amt, symbol) => {
  amt && typeof amt === "string" && amt.replaceAll(",", "");
  const newAmt = typeof amt === "string" ? amt.replaceAll(",", "") : amt;
  if (/[1-9]/.test(amt))
    return !symbol ? Number(Number(newAmt).toFixed(2)) : symbol + " " + newAmt;
  else if (Number(Number(newAmt).toFixed()) === 0) return "-";
  else if (!amt) return "-";
};

export const showDashIfZeroQty = (amt, symbol) => {
  if (/[1-9]/.test(amt))
    return !symbol ? Number(Number(amt).toFixed()) : symbol + amt;
  else if (Number(Number(amt).toFixed()) === 0) return "-";
};

export const getExcelNumData = (data) => {
  const numData = Number(Number(data).toFixed(2));
  return numData !== 0 ? numData : "";
};

export const getExcelNumData2 = (data, infinity, dot) => {
  if (infinity) {
    return data && !isNaN(data) && Number(data) !== 0
      ? Number(Number(data)?.toFixed(dot))
      : "-";
  } else {
    return data && !isNaN(data) ? Number(Number(data)?.toFixed(dot)) : "-";
  }
};

export const showPercentageDash = (amt) => {
  if (!isNaN(amt)) {
    return `${showDashIfZero(amt)}${showDashIfZero(amt) === "-" ? "" : "%"}`;
  } else {
    return amt + "%";
  }
};

export const removeSymbol = (value) => {
  let newValue = value?.replaceAll("/", "-");
  return newValue;
};

export const getDateForCalender = (dateData) => {
  return dateData < 10 ? "0" + dateData : dateData;
};

export const lakhAmtToOriginal = (amt) => {
  const newNum = Number(String(amt)?.replaceAll(",", ""));
  return !isNaN(newNum) ? (Number(newNum) * 100000).toFixed(2) : "-";
};

export const lakhData = (data) => {
  return data && data === "-" ? "-" : Number(data);
};

export const dashIfNull = (data) => {
  return data ? data : "-";
};

export const showAmtWithValue = (data, unit) => {
  return data && !isNaN(data)
    ? Number(Number(data)?.toFixed(2))?.toLocaleString("hi-IN") + unit
    : data + unit;
};

export const lakhAmt = (amt) => {
  if (!amt) return undefined;
  return Number((Number(amt) / 100000).toFixed(2)).toLocaleString("hi-IN");
};
export const getTabs = (name, ty) => {
  return `${name[0]?.toUpperCase()}${name?.substring(1)?.toLowerCase()}`;
};

export const findBank = (code) => {
  const { banks } = bankList;
  const findBankItem = banks.find((item) => item.bank_code === code);
  if (findBankItem) {
    return findBankItem.icon;
  }
  return bankDefault;
};

export const findAmc = (code) => {
  const { amcs } = amcList;
  const findBankItem = amcs.find((item) => item.amc_id === code);
  if (findBankItem) {
    return findBankItem.icon;
  }
  return bankDefault;
};

export const getBankImg = (bankName) => {
  const arr = bankName.split(" ");

  const str = arr.reduce((acc, elem, i) => {
    if (i !== 0 && elem) {
      return acc + elem[0];
    } else return acc;
  }, arr[0][0]);

  const bankString =
    arr.length <= 2 ? arr[0].substring(0, 4).toLowerCase() : str.toLowerCase();

  switch (bankString) {
    case "citi":
      return bankCITI;
    case "hbl":
      return bankHDFC;
    case "hdfc":
      return bankHDFC;
    case "icic":
      return bankICIC;
    case "pnb":
      return bankPUNB;
    case "bob":
      return bankBABO;
    case "sboi":
      return bankSBIN;
    default:
      return bankDefault;
  }
};

export const getDateToSend = (date) => {
  const month =
    monthsData2.indexOf(date?.month.slice(0, 3)) < 10
      ? `0${monthsData2.indexOf(date?.month.slice(0, 3))}`
      : monthsData2.indexOf(date?.month.slice(0, 3));

  const formatedDate = date?.date;

  return `${date.year}-${month}-${formatedDate}`;
};

export const convertDateToObj = (datestr, isMonthInStr = false) => {
  if (datestr) {
    const [year, month, date] = datestr?.split("-");
    return {
      year,
      month: !isMonthInStr ? month : newMonthData[month],
      date,
    };
  }
};

export const convertDateToObjPerformance = (dateS) => {};

export const getEventDate = (data) => {
  const [date, month, year] = data?.split("/");
  return {
    year: year,
    month,
    date,
  };
};

export const convertDateToObj2 = (datestr) => {
  if (datestr) {
    const [year, month, date] = datestr?.split("/");
    return {
      year,
      month,
      date,
    };
  }
};

export const getSortedUser = (usersData) => {
  const copiedData = usersData;
  let primaryIndex = null;

  const poppedElem = copiedData?.splice(primaryIndex, 1);
  copiedData?.unshift(poppedElem[0]);

  return copiedData || [];
};

export const padNumber = (number) => {
  let str = "" + number;
  return (str = str.length < 2 ? "0" + str : str);
};

export const getbroker = (brokerName) => {
  switch (brokerName) {
    case "NSDL":
      return nsdllogo;
    case "CDSL":
      return cdsllogo;
    default:
      return nsdllogo;
  }
};

export const getAccountNum = (acc_num) => {
  let ind1 = 4;
  const str = String(acc_num)
    .split("")
    .reduce((acc, cur, idx) => {
      if (idx === ind1) {
        ind1 = ind1 + 5;
        return acc + " " + cur;
      }
      return acc + cur;
    }, "");
  return str;
};

export const breadCrumbArray = (newArr) => {
  newArr.shift();
  let path = "";
  const arr2 = newArr.map((data) => {
    path = `${path}/${data}`;
    let obj = {
      path: path,
      show: data,
    };
    return obj;
  });
  return arr2;
};

export const assetClass = {
  2: "Equity",
  3: "Hybrid/Multi Asset",
  4: "Fixed Income",
  5: "Alternatives",
};

export const breadCrumbArray2 = (
  assetClassId,
  newArr,
  name,
  name2,
  from,
  isF,
) => {
  newArr?.shift();
  let path = "";
  const arr2 = newArr.map((data, index) => {
    path = `${path}/${data}`;
    let obj = {};
    obj = {
      path: path,
      show: data,
    };
    if (index === 1) {
      let checkData = assetClass?.[newArr[2]?.split("_")?.[0]];
      let fixeObj = {
        path: path,
        show:
          assetClassId !== 6
            ? checkData
              ? checkData + " Performance"
              : "Derivatives Performance"
            : "Derivatives Performance",
      };
      if (from)
        obj = {
          ...fixeObj,
          state: {
            ...from,
          },
        };
      else
        obj = {
          ...fixeObj,
        };
    } else if (index === 2) {
      obj = {
        path: path,
        show: name + " Performance",
      };
    } else if (index === 3) {
      obj = {
        path: path,
        show: name2,
      };
    }

    return obj;
  });
  return arr2;
};

export const replace20 = (data) => {
  const str1 = data?.replace(/%20/g, " ");
  return str1?.replace(/;/g, " / ");
};
export const getMd5 = (str) => {
  return MD5(str);
};

export const locateTo = (path, locate) => {
  switch (locate) {
    case "Direct Equity":
      return `${path}/Equity-Direct Equity;Stocks`;
    case "Equity in Mutual Fund":
      return `${path}/Direct Equity stock`;
    case "Equity in PMS":
      return `${path}/Direct Equity stock`;
    case "Mutual Fund - Debt":
      return `${path}/Mutual Fund - Debt Summary`;
    case "Structured Products - Debt":
      return `${path}/Structured Products - Debt`;
    case "Alternatives Others":
      return `${path}/Alternatives Others Summary`;
    case "Hybrid":
      return `${path}/Hybrid - PMS`;
    case "Cash":
      return `${path}/cash`;

    default:
      return `${path}/${locate}`;
  }
};

export const getFirstTimePdfData = (data, isAscending, type, key, extraKey) => {
  if (type === "normal") {
    if (isAscending) {
      return [...data]?.sort(
        (a, b) =>
          Number(a?.current_value?.actual_value) -
          Number(b?.current_value?.actual_value),
      );
    } else {
      [...data]
        ?.sort(
          (a, b) =>
            Number(a?.current_value?.actual_value) -
            Number(a?.current_value?.actual_value),
        )
        .reverse();
    }
  } else {
    if (isAscending) {
      return [...data]?.sort((a, b) => Number(a?.[key]) - Number(b?.[key]));
    } else {
      [...data]?.sort((a, b) => Number(a?.[key]) - Number(b?.[key])).reverse();
    }
  }
};

export const textEllipsis = (text) => {
  return text?.length > 13 ? text?.substring(0, 12) + "..." : text;
};

export const getCurrentDate = () => {
  const dateNow = new Date();
  const monthNow = dateNow.getMonth() + 1;
  const mm = monthNow < 10 ? "0" + monthNow : monthNow;
  return `${
    dateNow.getDate() < 10 ? "0" + dateNow.getDate() : dateNow.getDate()
  }_${mm}_${dateNow.getFullYear()}`;
};

export const getCurrentDateYYYYMMDD = () => {
  const dateNow = new Date();
  const monthNow = dateNow.getMonth() + 1;
  const mm = monthNow < 10 ? "0" + monthNow : monthNow;
  return `${dateNow.getFullYear()}-${mm}-${
    dateNow.getDate() < 10 ? "0" + dateNow.getDate() : dateNow.getDate()
  }`;
  // `${
  //   dateNow.getDate() < 10 ? "0" + dateNow.getDate() : dateNow.getDate()
  // }_${mm}_${dateNow.getFullYear()}`;
};

export function getCurrentDateAndTimeDDMMYYHHMM() {
  const currentDate = new Date();

  function getValue({ data }) {
    return String(data).padStart(2, "0");
  }

  const day = getValue({ data: currentDate.getDate() });
  const month = getValue({ data: currentDate.getMonth() + 1 });
  const year = String(currentDate.getFullYear()).slice(-2);

  const hours = getValue({ data: currentDate.getHours() });
  const minutes = getValue({ data: currentDate.getMinutes() });

  return `${day}${month}${year}${hours}${minutes}`;
}

export const getDDMMYYY = (date) => {
  if (!date) return;

  const readDate = new Date(date);
  const yyyy = readDate.getFullYear();
  let mm = readDate.getMonth() + 1; // Months start at 0!
  let dd = readDate.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = dd + "-" + mm + "-" + yyyy;

  return formattedToday;
};

export const getDateForSortTax = (data) => {
  const newData = data || "";

  if (!newData) {
    return 0;
  } else if (newData?.includes("/")) {
    const dArray = newData?.split("/");
    return Number(dArray[2].concat(dArray[1], dArray[0]));
  } else if (newData?.includes("-")) {
    return newData?.split("-").join();
  }
};

export const getDisplayDate2 = (data) => {
  // date format dd/mm/yyyy
  if (!data) return;
  const newArr = data?.split("/");

  return newArr
    ? `${newArr[0]} ${monthsData[Number(newArr[1])]} ${newArr[2]}`
    : data;
};
export const getDisplayDate3 = (data) => {
  // date format mm/dd/yyyy
  if (!data) return;
  const newArr = data?.split("/");

  return newArr
    ? `${newArr[1]} ${monthsData[Number(newArr[0])]} ${newArr[2]}`
    : data;
};

export const getMaturityDate = (data) => {
  //get maturity date
  if (data) {
    if (data?.includes("/")) {
      return getDisplayDate3(data?.split(" ")?.[0]);
    } else if (data?.includes("-")) {
      return getDisplayDate(data?.split(" ")?.[0]);
    }
  } else return "";
};

export const getSubAssetDate = (data, isFullYear) => {
  return data
    ? `As on ${
        isFullYear ? getDisplayDate(data) : getDisplayDateWithoutWholeYear(data)
      }`
    : "-";
};

export const getDisplayDateWithoutWholeYear = (data) => {
  if (!data) return;
  const newArr = data?.split("-");

  return newArr
    ? `${newArr[2]} ${monthsData[Number(newArr[1])]} ${
        parseInt(newArr[0]) - 2000
      }`
    : data;
};

export const getDisplayDate = (data) => {
  // get display date
  if (!data) return "";
  const newArr = data?.split("-");

  return newArr
    ? `${newArr[2]} ${monthsData[Number(newArr[1])]} ${newArr[0]}`
    : data;
};

export const portfolioExcel = (data) => {
  return !isNaN(data) ? Number(Number(data).toFixed(2)) : "";
};

export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const removeBracket = (data) => {
  const reg = /[(,)]/g;
  const newData = data?.replace(reg, "");
  const Data = newData?.replaceAll(",", "");

  return Data;
};

export const replaceComma = (data) => {
  const newData = data?.replaceAll(",", "");
  return !isNaN(newData) ? data?.replaceAll(",", "") : "-";
};

export const sortDateLedger = (data) => {
  const newData = data?.split(" ");
  return newData[2]?.concat(getMonthNum[newData[1]], newData[0]);
};

export const getExcelDate = (data) => {
  if (!data) return;
  const newArr = data?.split("-");

  return newArr
    ? `${Number(newArr[2])}/${Number(newArr[1])}/${Number(newArr[0])}`
    : data;
};

export const pdfMaturityDate = (data) => {
  if (!data) return;
  const newArr = data?.split(" ")?.[0]?.split("/");

  return newArr
    ? `${Number(newArr[1])}/${Number(newArr[0])}/${Number(newArr[2])}`
    : data;
};

export const excelMaturityDate = (data) => {
  if (!data) return;
  const newStr = data?.split(" ")?.[0];

  return newStr ? new Date(newStr) : data;
};

export const getLedgerExcelDate = (data) => {
  if (!data) return "";
  else {
    const newArr = data?.split(" ");
    return `${Number(newArr[0])}/${Number(getMonthNum[newArr[1]])}/${
      newArr[2]
    }`;
  }
};

export const getDateInNum2 = (dateString) => {
  const splitArray = dateString?.split("-");
  return `${splitArray?.[0]}${splitArray?.[1]}${splitArray?.[2]}`;
};

export const convertToDate = (dateObj) => {
  const date1 = dateObj?.getDate();
  const dateMonth = dateObj?.getMonth() + 1;
  function getNum(data2) {
    return data2 < 10 ? "0" + data2 : data2;
  }
  return `${dateObj?.getFullYear()}-${getNum(dateMonth)}-${getNum(date1)}`;
};

export const isShowHomeModal = (asOfDate) => {
  const todaysDate = new Date();

  const diff =
    new Date(convertToDate(todaysDate)).getTime() -
    new Date(asOfDate).getTime();
  return diff > 86400000 ? true : false;
};

export const getTextColor = (text) => {
  return ttRedColorArr.includes(text?.toLowerCase()) ? "red_text" : "";
};

export const showDataWithRupeeDashOrZero = (data, isDash, currency) => {
  if (data) {
    const newData = data?.replaceAll(",", "");
    if (!isNaN(newData) && Number(newData) !== 0)
      return `₹ ${commaSeperated(newData)}`;
    else if (!isDash) return "0";
    else return "-";
  } else if (!isDash) {
    return "0";
  } else return "-";
};

export const displayAmountWithCurrency = (data, currency) => {
  if (data) {
    const newData = data?.replaceAll(",", "");
    if (!isNaN(newData) && Number(newData) !== 0) {
      return `${
        getSymbolFromCurrency(currency) ||
        currencySymbols[currency?.toLowerCase() || ""] ||
        ""
      } ${commaSeperated(newData)}`;
    } else {
      return "0";
    }
  } else {
    return "0";
  }
};

export const getLedgerExcelDate2 = (data) => {
  if (!data) return "-";
  else {
    const newArr = data?.split(" ");

    return newArr
      ? new Date(`${newArr[2]}-${getMonthNum[newArr[1]]}-${newArr[0]}`)
      : "-";
  }
};

export const getDisplayDateForExport = (data) => {
  if (!data) return;
  const newArr = data?.split("-");

  return newArr ? `${newArr[2]}-${newArr[1]}-${newArr[0]}` : data;
};

export const getBreadCrumbString = (assetId, vehicleId) => {
  return assetClass[assetId] + "-" + getSubAssetClasses(vehicleId);
};

export const getAmount = (data) => {
  return data?.substring(0, data?.indexOf(".") + 3);
};

export const getDefaultImageOrImage = ({
  profileClassname,
  imageSrc,
  clientName,
  imgStyle,
  defaultStyle,
}) => {
  if (imageSrc) {
    return (
      <img
        src={imageSrc}
        style={{ ...imgStyle }}
        className={profileClassname}
        alt="user"
      />
    );
  }

  return (
    <div style={{ ...defaultStyle }} className="profileImageDefaultConst">
      {clientName[0]}
    </div>
  );
};

export const NegativeNumber = (number) => {
  if (!number) return <></>;
  return Number(number) < 0 ? (
    <span style={{ color: "red" }}>{number}%</span>
  ) : (
    <span>{number}%</span>
  );
};

export const numWithUnit = (amt, unit, isInfinity) => {
  if (amt && !isNaN(amt)) {
    if (Number(amt) !== 0)
      return (
        <>
          {commaSeperated(amt)}&nbsp;
          <span
            className="unitFont forLineHeight"
            style={{
              color: "inherit",
              textTransform: "capitalize",
            }}
          >
            {unit !== "lacs" ? unit : "L"}
          </span>
        </>
      );
    else if (!isInfinity) return "0";
    else return "-";
  }
};

export const numWithUnitPerformance = (amount, unit) => {
  return !isNaN(amount) ? (
    <>
      {`${commaSeperated(amount)}`}{" "}
      <span className="unitFont">{`${unit !== "lacs" ? unit : "L"}`}</span>{" "}
    </>
  ) : (
    amount
  );
};

export const displayUnit = (unit) => {
  return unit === "lacs" ? "L" : unit === "k" ? "K" : unit;
};

export const getlevel2Data = (data, selectedValue) => {
  return data?.periodWiseData[selectedValue];
};

export const getPrintDate = (data) => {
  const dataNew = data?.split("-");
  return `${dataNew?.[2]}-${dataNew?.[1]}-${dataNew?.[0]}`;
};

export const getDecodedToken = () => {
  const data = getCookie("token")
    ? JSON.parse(atob(getCookie("token")?.split(".")?.[1]))
    : null;

  return getCookie("token")
    ? {
        ...data,
        primary: data.primary.toLowerCase(),
      }
    : null;
};

export const sortAccount = (arrData, key) => {
  for (let i = arrData?.length; i > 0; i--) {
    for (let j = 0; j < i; j++) {
      for (let k = 0; k < arrData?.[j]?.[key]?.length; k++) {
        let a = arrData?.[j]?.[key]?.charCodeAt(k);
        let b = arrData?.[j + 1]?.[key]?.charCodeAt(k);
        let temp = null;

        if (a < b) {
          temp = arrData?.[j];
          arrData[j] = arrData?.[j + 1];
          arrData[j + 1] = temp;
          break;
        } else if (a > b) {
          break;
        }
      }
    }
  }
  return arrData;
};

export const commaSeperatedValue = (data) => {
  const newData = data.replace(/\B(?=(?: (\d\d)+(\d)(?!\d)) +(?!\d))/g, ",");
  return newData;
};

export const isEmptyOverview = (overviewData) => {
  const value = overviewData?.reduce((acc, curr) => {
    return acc + curr.amount;
  }, "");
  return /[1-9]/.test(value);
};

export const getFileSize = (size, decimals = 2) => {
  if (size === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(size) / Math.log(k));
  return parseFloat(size / Math.pow(k, i)).toFixed(dm) + " " + sizes[i];
};

export const getAccountsLength = (length) => {
  return length === 0 ? `0` : length < 10 ? `0${length}` : `${length}`;
};

export const getNameWithInitials = (name) => {
  const initialsArray = name?.split(" ");
  return `${name} (${initialsArray[0][0]}${initialsArray[1][0]}${initialsArray[2][0]})`;
};

export const logout = () => {
  // moengage.destroy_session();

  clearTable();
  const cookieNames = getAllCookies();

  var result = Object.keys(cookieNames).map((key) => [key, cookieNames[key]]);
  for (let i = 0; i < result.length; i++) {
    deleteCookie(result[i][0]);
  }

  UserStore.setUserStoreToIntialState();
  SettingsStore.setSettingsStoreToIntialState();
  ReportsStore.setReportsStoreToIntialState();
  AuthStore.setAuthsStoreToIntialState();
  AnalyticsStore.setAnalyticsStoreToIntialState();
  PerformanceStore.setPerformanceStoreToIntialState();
  ProfileStore.setProfileStoreToIntialState();
  ProfileStore2.setProfileStore2ToIntialState();
};

export const checkUserEmailValidation = (userEmail) => {
  return String(userEmail)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

export const getExcelDate2 = (data, base) => {
  const newData = data ? data?.split(base) : "-";

  return !data ? newData : new Date(data);
};

export const getExcelDateddmmyyyy = (data, base) => {
  const newData = data ? data?.split(base) : "-";
  return !data
    ? newData
    : new Date(`${newData[2]}-${newData[1]}-${newData[0]}`);
};

export function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  var dataURL = canvas.toDataURL("image/png");
  return dataURL;
}
export const getExcelDateDMYUnGL = (data, base) => {
  const newData = data ? data?.split(base) : "";
  return !data
    ? newData
    : new Date(`${newData[2]}-${newData[1]}-${newData[0]}`);
};

export const exportExcel = async ({
  dateRange = null,
  isFamilyOnly = false,
  sheetname,
  columns,
  reportDetails,
  data,
  isInstrumentSummary,
  excelName,
  customNameWithTime,
  exportFrom,
  customExcelTableStyle,
  linkText = {
    text: excelPdfDisclaimerLink.text,
  },
  customSheetName = "",
  ...options
}) => {
  const currTime = new Date();
  const cTMinutes = currTime.getMinutes();
  const cTDate = currTime.getDate();
  const cTMonth = currTime.getMonth();
  const ctYear = currTime.getFullYear();

  const drawASheet = ({
    sheetname,
    dateRange,
    isFamilyOnly,
    columns,
    reportDetails,
    data,
    isInstrumentSummary,
    excelName,
    customNameWithTime,
    exportFrom,
    worksheet,
    customExcelTableStyle,
    linkText,
    ...options
  }) => {
    const columnsFiltered = columns.filter(
      (colum) => colum.showColumn || colum.label,
    );

    const metaNameTitle = !isFamilyOnly
      ? "Client/Family/Account Name : "
      : "Family Name : ";
    const metaDateTitle = !dateRange ? "Date : " : "Date Range : ";

    const metaTitle = {
      metaNameTitle,
      metaDateTitle,
      metaRMTitle: "Relationship Manager Name : ",
      metaSMTitle: "Service Manager Name : ",
    };

    const { clientName, date, relatioshipManager, serviceManager } =
      reportDetails;

    const excelReportDetails = {
      clientName: customNameWithTime || clientName,
      date: !dateRange ? date : dateRange,
      relatioshipManager,
      serviceManager,
    };
    const clmLength = columnsFiltered.length;
    const reportsMetaData = Object.values(excelReportDetails);
    const reportsMetaTitle = Object.values(metaTitle);
    const detailsRow = [2, 3, 4, 5];

    const excelMeta = {
      time: {
        value: `Report Generated  ${currTime.toLocaleTimeString(undefined, {
          hour: "2-digit",
          hour12: false,
        })}:${pad0(cTMinutes)} :: ${pad0(cTDate)}/${
          cTMonth < 9 ? `0${cTMonth + 1}` : cTMonth + 1
        }/${ctYear}`,
        alignment: {
          horizontal: "right",
        },
      },
      link: {
        value: {
          text: linkText.text,
          hyperlink: excelPdfDisclaimerLink.link,
        },
        font: {
          color: { argb: "FF0000EE" },
        },
      },
    };

    const btm3rows = {
      column: clmLength + (clmLength === 2 ? 1 : -1),
      arr: [11, 13, 14].map((d) => d + data.length),
    };

    const cellNames = columnsFiltered.map((_, i) =>
      String.fromCharCode(65 + i),
    );

    const columnNames = [...excelClmReference];
    // cellnames is an array of excel cell alphabets [A , b , c ...] ... lts length will be number of columns we want to print

    function printSheetNameAndStyle({ column }) {
      worksheet.mergeCells(`A1:${String.fromCharCode(65 + column)}1`);
      worksheet.getCell("A1").value = `${sheetname}`;
      worksheet.getCell("A1").alignment = {
        vertical: "middle",
        horizontal: "center",
      };

      worksheet.getCell("A1").font = {
        size: 16,
        bold: true,
      };
    }

    function styleDetailsRow({ column, values }) {
      detailsRow.forEach((num, idx) => {
        const { font, alignment } = xlDetailsStyle;

        function styleDetails({ type, style }) {
          worksheet.getCell(`${String.fromCharCode(65 + column)}${num}`)[type] =
            style;
        }

        styleDetails({ type: "font", style: font });
        styleDetails({ type: "alignment", style: alignment });
        styleDetails({ type: "value", style: values[idx] });
      });
    }

    const merge3Rows = ({ column, arr }) => {
      (arr || [6, 7, 8]).forEach((num) => {
        worksheet.mergeCells(
          `A${num}:${String.fromCharCode(65 + column)}${num}`,
        );
      });
    };

    const getCode = (value) => {
      const lastCell = data.length + 12;
      return `${String.fromCharCode(65 + clmLength + value)}${lastCell}`;
    };

    const nuvamaLogoImg = workbook.addImage({
      base64: getBase64Image(document.getElementById("nuvamaexcel")),
      extension: "png",
    });

    if (columnsFiltered.length === 2) {
      // to print user details
      worksheet.getColumn(3).width = 33;
      worksheet.getColumn(4).width = 33;
      printSheetNameAndStyle({ column: clmLength + 1 });
      styleDetailsRow({ column: clmLength, values: reportsMetaTitle });
      styleDetailsRow({ column: clmLength + 1, values: reportsMetaData });

      // this gives 3 straight rows , first two rows are white in color and last row is golden
      merge3Rows({ column: clmLength + 1 });
      worksheet.mergeCells(`A9:B9`);
      worksheet.mergeCells(`C9:D9`);
      data?.forEach((_, i) => {
        worksheet.mergeCells(`A${i + 10}:B${i + 10}`);
        worksheet.mergeCells(`C${i + 10}:D${i + 10}`);
      });

      // this gives style and values to the header
      const headerNames = columnsFiltered.map(({ label, labelPdf }) => {
        return typeof label === "object" ? labelPdf : label;
      });

      worksheet.getCell("A9").value = headerNames[0];
      worksheet.getCell("C9").value = headerNames[1];
      worksheet.getCell("A9").fill = headerFill;
      worksheet.getCell("A9").font = headerFont;
      worksheet.getCell("C9").fill = headerFill;
      worksheet.getCell("C9").font = headerFont;

      //add data to the excel table
      data?.forEach((subassetClassObject, parentIndex) => {
        let subassetArray = [];
        columnsFiltered.forEach((elm, index) => {
          if (elm.cellRendererPdf) {
            subassetArray.push(
              elm.cellRendererPdf(
                subassetClassObject[elm.key],
                subassetClassObject,
                elm.key,
              ),
            );
          } else {
            subassetArray.push(subassetClassObject[elm.key]);
          }
        });
        worksheet.getCell(`A${parentIndex + 10}`).value = subassetArray[0];
        worksheet.getCell(`C${parentIndex + 10}`).value = subassetArray[1];
      });
    } else {
      // to print user details
      worksheet.getColumn(3).style = { width: "max-content" };
      printSheetNameAndStyle({ column: clmLength - 1 });
      styleDetailsRow({ column: clmLength - 2, values: reportsMetaTitle });
      styleDetailsRow({ column: clmLength - 1, values: reportsMetaData });

      // this gives 3 straight rows , first two rows are white in color and last row is golden
      merge3Rows({ column: clmLength - 1 });

      // Give values to the table header
      worksheet.getRow(9).values = columnsFiltered.map(
        ({ label, labelPdf }) => {
          return typeof label === "object" ? labelPdf : label;
        },
      );

      //add data to the excel table
      data?.forEach((subassetClassObject, parentIndex) => {
        let subassetArray = [];
        columnsFiltered.forEach((elm, index) => {
          if (elm.cellRendererExcel) {
            subassetArray.push(
              elm.cellRendererExcel(
                subassetClassObject[elm.key],
                subassetClassObject,
                elm.key,
              ),
            );
          } else if (elm.cellRendererPdf) {
            subassetArray.push(
              elm.cellRendererPdf(
                subassetClassObject[elm.key],
                subassetClassObject,
                elm.key,
              ),
            );
          } else {
            subassetArray.push(subassetClassObject[elm.key]);
          }
        });

        worksheet.getRow(parentIndex + 10).values = subassetArray;
      });
    }

    // line which starts before table
    worksheet.getCell("A8").fill = goldenFill;

    // table header alignment
    worksheet.getRow(9).eachCell((cell) => {
      cell.alignment = {
        horizontal: "center",
      };
    });

    // this gives style to tbody
    if (!customExcelTableStyle) {
      worksheet.eachRow(function (row, rowNumber) {
        if (rowNumber > 8) {
          row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
            if (
              columnNames.includes(worksheet.getRow(9).getCell(colNumber).value)
            ) {
              if (rowNumber > 9) {
                row.getCell(colNumber).alignment = {
                  horizontal:
                    exportFrom && exportFrom === "portfolioPage1"
                      ? "left"
                      : "right",
                };
              }
            }
            if (
              row.getCell(colNumber).value === "-" ||
              row.getCell(colNumber).value === "-"
            ) {
              row.getCell(colNumber).alignment = {
                horizontal: "right",
              };
            } else if (
              (typeof row.getCell(colNumber).value !== "object" &&
                typeof row.getCell(colNumber).value !== "number" &&
                row.getCell(colNumber).value &&
                !isNaN(
                  row.getCell(colNumber).value?.replaceAll(",", "") || "a",
                )) ||
              (typeof row.getCell(colNumber).value !== "object" &&
                typeof row.getCell(colNumber).value !== "number" &&
                row.getCell(colNumber).value &&
                !isNaN(
                  row.getCell(colNumber).value?.replaceAll("/", "") || "a",
                ))
            ) {
              row.getCell(colNumber).alignment = {
                horizontal: "right",
              };
            }
            if (typeof row.getCell(colNumber).value === "number") {
              row.getCell(colNumber).alignment = {
                horizontal: "right",
                //  wrapText:true,
                shrinkToFit: true,
              };
            }

            row.getCell(colNumber).border = {
              bottom: {
                style: "thin",
              },
              left: {
                style: "thin",
              },
            };
            row.getCell(colNumber).alignment = {
              ...row.getCell(colNumber).alignment,
              wrapText: true,
            };
            if (rowNumber === data.length + 9) {
              row.getCell(colNumber).border = {
                bottom: {
                  style: "thin",
                },
                left: {
                  style: "thin",
                },
              };
            }
            if (data[rowNumber - 10]?.primary) {
              row.getCell(colNumber).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FFFE08A",
                  // rosegold colorof primary data
                },
              };
            }
            if (data[rowNumber - 10]?.secondary) {
              row.getCell(colNumber).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FF95B3D7",
                  // rosegold colorof primary data
                },
              };
            }
            if (data[rowNumber - 10]?.tertiary) {
              row.getCell(colNumber).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FFCCA75E",
                  // rosegold colorof primary data
                },
              };
            }
          });
        }
      });
    } else customExcelTableStyle({ worksheet, data });

    // style to the columns
    cellNames.forEach((element) => {
      worksheet.getCell(`${element}9`).fill = headerFill;
      worksheet.getCell(`${element}9`).font = headerFont;
    });

    worksheet.getCell(`${getCode(-2)}`).font = {
      bold: true,
      size: 14,
    };

    // this adds nuvama logo
    worksheet.addImage(nuvamaLogoImg, {
      tl: { col: 0, row: 1 },
      br: { col: 1, row: 5 },
    });

    if (clmLength === 2) worksheet.mergeCells(`${getCode(-2)}:${getCode(1)}`);
    else worksheet.mergeCells(`${getCode(-2)}:${getCode(-1)}`);

    worksheet.getCell(`${getCode(-1)}`).value = excelMeta.time.value;
    worksheet.getCell(`${getCode(-1)}`).alignment = excelMeta.time.alignment;

    merge3Rows(btm3rows);

    worksheet.getCell(`A${data.length + 13}`).fill = goldenFill;

    worksheet.getCell(`A${data.length + 14}`).value = excelMeta.link.value;
    worksheet.getCell(`A${data.length + 14}`).font = excelMeta.link.font;
    // "Master Disclaimer - Footer section ( for disclaimer as sample)";

    worksheet.columns = columnsFiltered;

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length + 1 : 10;
        if (cell.type === excel.ValueType.Date) {
          maxLength = 17;
        } else if (columnLength > maxLength) {
          maxLength = columnLength + 1;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });

    let columnslen = cellNames?.length;
    cellNames.forEach((name, index) => {
      if (index === 0) {
        worksheet.getColumn(name).width = 33;
      } else if (index === columnslen - 2) {
        worksheet.getColumn(name).width = 28;
      } else if (index === columnslen - 1) {
        worksheet.getColumn(name).width = 30;
      }
    });

    worksheet.getCell("A1").value = `${sheetname}`;

    const createOuterBorder = (
      worksheet,
      start = { row: 1, col: 1 },
      end = { row: 1, col: 1 },
      borderWidth = "medium",
    ) => {
      const borderStyle = {
        style: borderWidth,
      };
      for (let i = start.row; i <= end.row; i++) {
        const leftBorderCell = worksheet.getCell(i, start.col);
        const rightBorderCell = worksheet.getCell(i, end.col);
        leftBorderCell.border = {
          ...leftBorderCell.border,
          left: borderStyle,
        };
        rightBorderCell.border = {
          ...rightBorderCell.border,
          right: borderStyle,
        };
      }

      for (let i = start.col; i <= end.col; i++) {
        const topBorderCell = worksheet.getCell(start.row, i);
        const bottomBorderCell = worksheet.getCell(end.row, i);
        topBorderCell.border = {
          ...topBorderCell.border,
          top: borderStyle,
        };
        bottomBorderCell.border = {
          ...bottomBorderCell.border,
          bottom: borderStyle,
        };
      }
    };

    const detailsBorderArr = clmLength === 2 ? [1, 2] : [-1, 0];

    detailsBorderArr.forEach((num) => {
      createOuterBorder(
        worksheet,
        { row: 2, col: clmLength + num },
        { row: 5, col: clmLength + num },
      );
    });
  };
  const workbook = new excel.Workbook();
  if (!options.isAll) {
    const worksheet = workbook.addWorksheet(customSheetName || sheetname, {
      headerFooter: {
        firstHeader: options.firstHeader,
        firstFooter: options.firstFooter,
      },
    });
    drawASheet({
      dateRange,
      isFamilyOnly,
      sheetname,
      columns,
      reportDetails,
      data,
      isInstrumentSummary,
      excelName,
      customNameWithTime,
      exportFrom,
      worksheet,
      customExcelTableStyle,
      linkText,
      ...options,
    });
  } else {
    const keyArr = Object.entries(data);
    for (let i = 0; i < keyArr.length; i++) {
      const worksheet = workbook.addWorksheet(keyArr[i][0], {
        headerFooter: {
          firstHeader: options.firstHeader,
          firstFooter: options.firstFooter,
        },
      });
      drawASheet({
        dateRange,
        isFamilyOnly,
        sheetname,
        columns: Object.values(options.allColumns)[i],
        reportDetails,
        data: keyArr[i][1],
        isInstrumentSummary,
        excelName,
        customNameWithTime,
        exportFrom,
        worksheet,
        customExcelTableStyle,
        linkText,
        ...options,
      });
    }
  }

  // download and save the excel
  workbook.xlsx.writeBuffer().then(function (data) {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download =
      excelName !== undefined
        ? `${excelName}.xls`
        : `${
            customNameWithTime || UserStore.getData === "fam"
              ? UserStore.userData?.family_name
              : UserStore.userData?.full_name
          }_${currTime.getDate()}:${currTime.getMonth()}:${currTime.getFullYear()}.xls`;

    anchor.click();
    window.URL.revokeObjectURL(url);
  });
};

export const printDocument = (id, props, disclaimerId = "masterDisclaimer") => {
  const input = document.getElementById(id);
  document.getElementById(id).style.display = "block";
  html2canvas(input, {
    useCORS: true,
    allowTaint: true,
    scrollY: -window.scrollY,
    quality: 4,
    scale: 2,
    onclone: (clonedDoc) => {
      clonedDoc.getElementById(id).style.display = "block";
    },
  }).then((canvas) => {
    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const imgWidth = 210;
    const pageHeight = 295;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    const doc = new jsPDF("p", "mm");
    let position = 0;
    let pageCount = 0;

    doc.addImage(imgData, "JPEG", 0, 20, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      pageCount++;
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const disclaimerElement = document.getElementById(disclaimerId);

    if (disclaimerElement) {
      //const linkXAxis = 5;
      const linkXAxis =
        (disclaimerElement.offsetLeft * imgWidth) / input.offsetWidth - 1;

      const linkWidth = (150 * imgWidth) / input.offsetWidth;
      const linkHeight = 3;

      const linkUrl = {
        url: excelPdfDisclaimerLink.link,
      };

      if (pageCount === 0) {
        doc.link(
          linkXAxis,
          pageHeight + heightLeft + 17,
          linkWidth,
          linkHeight,
          linkUrl,
        );
      } else {
        doc.link(
          linkXAxis,
          pageHeight + heightLeft - 3,
          linkWidth,
          linkHeight,
          linkUrl,
        );
      }
    }

    const fileName =
      props.nameWithoutDateTime !== undefined
        ? props.nameWithoutDateTime
        : `${props.name || ""} - ${getCurrentDate()}.pdf`;

    doc.save(props.customFileName ? `${props.customFileName}.pdf` : fileName);
  });
};

export const getBlobToBase64 = (imageBlob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(imageBlob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

export const getOverviewPdfFilterData = (data) => {
  let sendArray = data?.map((eachData) => {
    return eachData?.isHeader === "1"
      ? { asset: eachData?.asset, amount: "", isHeader: eachData?.isHeader }
      : {
          asset: eachData?.asset,
          amount: eachData?.amount,
          isHeader: eachData?.isHeader,
        };
  });

  return sendArray;
};

export const getOperatingSystem = (window) => {
  let operatingSystem = "Others";
  if (window.navigator.appVersion.indexOf("Win") !== -1) {
    operatingSystem = "Windows OS";
  }
  if (window.navigator.appVersion.indexOf("Mac") !== -1) {
    operatingSystem = "Mac OS";
  }
  if (window.navigator.appVersion.indexOf("X11") !== -1) {
    operatingSystem = "UNIX OS";
  }
  if (window.navigator.appVersion.indexOf("Linux") !== -1) {
    operatingSystem = "Linux OS";
  }

  return operatingSystem;
};

export const getBrowserDetails = () => {
  var nAgt = navigator.userAgent;
  var browserName = navigator.appName;
  var fullVersion = "" + parseFloat(navigator.appVersion);
  var majorVersion = parseInt(navigator.appVersion, 10);
  var nameOffset, verOffset, ix;

  // In Opera, the true version is after "OPR" or after "Version"
  if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
    browserName = "Opera";
    fullVersion = nAgt.substring(verOffset + 4);
    if ((verOffset = nAgt.indexOf("Version")) !== -1)
      fullVersion = nAgt.substring(verOffset + 8);
  }
  // In MS Edge, the true version is after "Edg" in userAgent
  else if ((verOffset = nAgt.indexOf("Edg")) !== -1) {
    browserName = "Microsoft Edge";
    fullVersion = nAgt.substring(verOffset + 4);
  }
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
    browserName = "Microsoft Internet Explorer";
    fullVersion = nAgt.substring(verOffset + 5);
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
    browserName = "Chrome";
    fullVersion = nAgt.substring(verOffset + 7);
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
    browserName = "Safari";
    fullVersion = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf("Version")) !== -1)
      fullVersion = nAgt.substring(verOffset + 8);
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
    browserName = "Firefox";
    fullVersion = nAgt.substring(verOffset + 8);
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if (
    (nameOffset = nAgt.lastIndexOf(" ") + 1) <
    (verOffset = nAgt.lastIndexOf("/"))
  ) {
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);
    if (browserName.toLowerCase() === browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }
  // trim the fullVersion string at semicolon/space if present
  if ((ix = fullVersion.indexOf(";")) !== -1)
    fullVersion = fullVersion.substring(0, ix);
  if ((ix = fullVersion.indexOf(" ")) !== -1)
    fullVersion = fullVersion.substring(0, ix);

  majorVersion = parseInt("" + fullVersion, 10);
  if (isNaN(majorVersion)) {
    fullVersion = "" + parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion, 10);
  }
  return `${browserName} ${majorVersion}`;
};

export const getDateAndMonth = (data) => {
  return data < 10 ? `0${data}` : data;
};

export const getAsOfDate = (data) => {
  const dateObj = new Date();
  const currDate = `${dateObj.getFullYear()}-${getDateAndMonth(
    dateObj.getMonth() + 1,
  )}-${getDateAndMonth(dateObj.getDate())}`;
  return data ? data : currDate;
};

export const alphanumeric_unique = () => {
  const id = Math.random()
    .toString(36)
    .split("")
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    })
    .join("")
    .substr(2, 8);

  UserStore.setDeviceId(id);
  return id;
};

export const sortingFuction = (localKey, arrData, localCondition) => {
  for (let i = arrData?.length; i > 0; i--) {
    for (let j = 0; j < i; j++) {
      let valueToCheck = "";
      let nextValueToCheck = "";
      if (localKey?.key2 === undefined) {
        valueToCheck = arrData?.[j]?.[localKey.key1];
        nextValueToCheck = arrData?.[j + 1]?.[localKey.key1];
      } else if (localKey?.key3 === undefined) {
        valueToCheck = arrData?.[j]?.[localKey.key1]?.[localKey.key2];
        nextValueToCheck = arrData?.[j + 1]?.[localKey.key1]?.[localKey.key2];
      } else {
        valueToCheck =
          arrData?.[j]?.[localKey.key1]?.[localKey.key2]?.[localKey.key3];
        nextValueToCheck =
          arrData?.[j + 1]?.[localKey.key1]?.[localKey.key2]?.[localKey.key3];
      }
      let tempValueToCheck = valueToCheck;

      if (
        isNaN(Number(tempValueToCheck?.replaceAll("-", ""))) &&
        isNaN(tempValueToCheck?.replaceAll(",", ""))
      ) {
        for (let k = 0; k < valueToCheck?.length; k++) {
          let a = valueToCheck?.charCodeAt(k);
          let b = nextValueToCheck?.charCodeAt(k);
          let temp = null;

          if (a > b && a - b !== 32) {
            temp = arrData?.[j];
            arrData[j] = arrData?.[j + 1];
            arrData[j + 1] = temp;
            break;
          } else if (a < b && a - b !== 32) {
            break;
          }
        }
      } else if (
        valueToCheck?.includes(".") ||
        valueToCheck?.includes(",") ||
        !isNaN(valueToCheck) ||
        (valueToCheck?.includes("-") && valueToCheck?.indexOf("-") === 0)
      ) {
        let temp = null;
        let firstValue = valueToCheck?.replaceAll(",", "");
        let secondValue = nextValueToCheck?.replaceAll(",", "");
        if (Number(firstValue) > Number(secondValue)) {
          temp = arrData?.[j];
          arrData[j] = arrData?.[j + 1];
          arrData[j + 1] = temp;
        }
      } else {
        let temp = null;
        if (
          Number(valueToCheck?.replaceAll("-", "")) >
          Number(nextValueToCheck?.replaceAll("-", ""))
        ) {
          temp = arrData?.[j];
          arrData[j] = arrData?.[j + 1];
          arrData[j + 1] = temp;
        }
      }
    }
  }

  return {
    localKey:
      localKey.key2 !== undefined && localKey.key2 === "xirr"
        ? localKey.key2
        : localKey.key1,
    arrData: arrData,
    sortOrder: localCondition,
  };
};

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function initSentry() {
  const isProd = window.location.host === "wealthlogin.nuvamaprivate.com";
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
          "localhost",
          /^https:\/\/yourserver\.io\/api/,
        ],
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: isProd ? 0.1 : 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: isProd ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: isProd ? "production" : "development",
  });
}

// const env = process.env.REACT_APP_ENV || "development";

// const config = {
//   development: {
//     baseURL: "/",
//   },
//   staging: {
//     baseURL: "/new",
//   },
//   uat: {
//     baseURL: "/new_uat",
//   },
// };

// export const getConfig = () => {

//   return config[env];
// };

export const sortData = ({
  sortingOrder,
  rowData,
  keyName,
  keyName2,
  type,
}) => {
  let sortedData = [];
  if (type === "number") {
    sortedData = [...rowData]?.sort(
      (a, b) =>
        Number(!keyName2 ? a?.[keyName] : a?.[keyName2]) -
        Number(!keyName2 ? b?.[keyName] : b?.[keyName2]),
    );
    return sortingOrder ? sortedData : sortedData.reverse();
  } else if (type === "string") {
    sortedData = [...rowData]?.sort((a, b) =>
      b?.[keyName].localeCompare(a?.[keyName]),
    );
    return !sortingOrder ? sortedData : sortedData.reverse();
  }
};

export const arrangeSnippets = ({ performanceArr, analyticsArr }) => {
  const newArr = [];
  const perfLength = performanceArr.length;
  const analyticsLength = analyticsArr.length;
  const L = perfLength < analyticsLength ? perfLength : analyticsLength;
  const remainingArr =
    perfLength < analyticsLength ? [...analyticsArr] : [...performanceArr];

  new Array(L).fill(1).forEach((_, idx) => {
    newArr.push(performanceArr[idx]);
    newArr.push(analyticsArr[idx]);
  });
  const lastData = [...remainingArr.splice(L)];

  return newArr.concat(lastData);
};

export const smothScroll = ({ id }) => {
  setTimeout(() => {
    const itemToScroll = document.getElementById(id);
    if (itemToScroll) {
      Scroll.animateScroll.scrollTo(itemToScroll?.getBoundingClientRect().top, {
        isDynamic: true,
        duration: 1700,
        smooth: true,
        delay: 100,
      });
    }
  }, 500);
};

export const smoothScrollTo = (target, duration) => {
  const targetPosition =
    target?.getBoundingClientRect()?.top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  // Animation function for smooth scrolling
  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  // Easing function for smoothness
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  requestAnimationFrame(animation);
};

export const isFromGivenPage = ({ location, page }) => {
  const from = location.state?.from;
  return from && from === page;
};
export const filters = ({ mainCheck, secondaryCheck, type, subType }) => {
  const getData = (data) => {
    return type === "date" ? data.timePeriod : data[subType];
  };

  const secDataToCheck = getData(secondaryCheck);
  const mainDataToCheck = getData(mainCheck);

  return secDataToCheck.value ? secDataToCheck : mainDataToCheck;
};

export const getSnippetText = ({ text }) => {
  const textArr = text?.split("/text")?.map((data, idx) => {
    const [normaltext, boldText] = data?.split("boldText");
    const [, clrText] = (boldText || "")?.split("_clrText");

    return boldText
      ? clrText
        ? { text: clrText, class: "greenText", key: idx + 1 }
        : { text: boldText, class: "boldText", key: idx + 1 }
      : { text: normaltext, class: "normalText", key: idx + 1 };
  });

  return textArr;
  // return text;
};

export const getSnippetObj = ({ data, isDisplayIrr }) => {
  const getSnippetText = ({ text }) => {
    const textArr = text.split("/text").map((data, idx) => {
      const [normaltext, boldText] = data?.split("boldText");

      const [, clrText] = (boldText || "")?.split("_clrText");

      return boldText
        ? clrText
          ? { text: clrText, class: "greenText", key: idx + 1 }
          : { text: boldText, class: "boldText", key: idx + 1 }
        : { text: normaltext, class: "normalText", key: idx + 1 };
    });

    return textArr;
    // return text;
  };

  const text = getSnippetText({
    text: isDisplayIrr
      ? data.irr || data.absolute_return
      : data.absolute_return || data.irr,
  });

  return text;
};

export const getCarousalText = ({ text }) => {
  return text;
};

export const getCardPercentage = ({
  width,
  numOfCards,
  extraSpace,
  margin,
}) => {
  return (
    (100 * (width - extraSpace + numOfCards * margin)) / (numOfCards * width)
  );
};

export const sortArrays = ({
  rowData,
  reqSortOrder,
  type,
  keysObj,
  keyLevel,
  dateFormat,
}) => {
  function getData({ data }) {
    return keyLevel === 1
      ? data[keysObj.key1]
      : keyLevel === 2
        ? data[keysObj.key1][keysObj.key2]
        : data[keysObj.key1][keysObj.key2][keysObj.key3];
  }

  function getDate({ data }) {
    switch (dateFormat) {
      case "ydm":
        return data?.split("-")?.join();
      default:
        return data?.split("-")?.join();
    }
  }

  const sortedData = [...rowData]?.sort((a, b) => {
    const dataFromClm1 = getData({ data: a });
    const dataFromClm2 = getData({ data: b });

    if (type === "numbers") return Number(dataFromClm1) - Number(dataFromClm2);
    else if (type === "strings")
      return dataFromClm1.localeCompare(dataFromClm2);
    else if (type === "date") {
      let aa = getDate({ data: dataFromClm1 });
      let bb = getDate({ data: dataFromClm2 });
      return aa < bb ? -1 : aa > bb ? 1 : 0;
    }
  });

  return reqSortOrder ? sortedData : sortedData.reverse();
};

export const getSubAssets = ({ data, benchXirr, fixedIncomeBM }) => {
  // to filtered sub asset classes add a new key called excelBenchMark ,
  // excelBenchMark for fixed Income will be of crisil bond and others would have nifty fifty
  const subAssetClasses = data
    ?.filter(
      (eachData) =>
        Number(Number(eachData.amount?.actual_value).toFixed()) +
          Number(Number(eachData.xirr || 0).toFixed()) !==
        0,
    )
    .map((classData) => {
      const excelBenchMark =
        classData.assetClass !== "Fixed Income" ? benchXirr : fixedIncomeBM;
      return { ...classData, excelBenchMark };
    });

  return subAssetClasses;
};

export const performanceExcelData2 = ({
  data,
  benchXirr,
  fixedIncomeBM,
  withHoldings,
}) => {
  const {
    performanceAssetandAllOverData: overallData,
    performanceInstumentData,
    performanceSubAssetData,
  } = data;

  // check if the sub asset absolute return and xirr addition is 0 or not
  // if its not 0 then only we have to show that sub assets and its instrument

  const subAssets = getSubAssets({
    data: performanceSubAssetData,
    benchXirr,
    fixedIncomeBM,
  });

  /* 
 How data is coming from api

 1. overall Data is array of object where 1st object is grand total of all the asset classes 
  and remaining objects are individual asset class total
 2. performanceInstumentData contains all the available instruments
 3. performanceSubAssetData contains all the sub asset classes which user possess and are in order  
 4. all above data is suppose to come in order in which we have to print the excelData
*/

  const newData = performanceInstumentData?.reduce((acc, curr) => {
    // {
    //   assetClass1 : [{... , instrument1},{... , instrumet2 and so on} , {...subassetTotal1} ,
    //                  {... , instrument1},{... , instrumet2 and so on} , {...subassetTotal2} ,
    //                  ...,
    //                  {...assetclass1Total}
    //                 ] ,
    //    assetClass2 : [{... , instrument1},{... , instrumet2 and so on} , {...subassetTotal1} ,
    //                  {... , instrument1},{... , instrumet2 and so on} , {...subassetTotal2} ,
    //                  ...,
    //                  {...assetclass2Total}
    //                 ] ,
    //   ...
    // }

    // Creates data in above format

    function reduceExcelData({ acc, curr }) {
      const subAssetData = subAssets?.find(
        (d) => d.investmentVehicleId === curr.investmentVehicleId,
      );

      // each instrument has its sub asset class and asset class in its object
      // if current assetClass is not there in the object ,then add it
      // else asset class is there but it can have either current sub asset class or any other
      //   if current asset class is there then add current instrument only and shift other data
      //   else add the current instrument with its sub asset below previous sub assets and its instrument to maintain the order

      if (subAssetData) {
        const benchMarkData = portfolioExcel(subAssetData.excelBenchMark);

        const getCurrentData = ({ data, benchMarkData }) => {
          return {
            ...data,
            excelAssetClass: data.instrumentName,
            excelAbsAmount: portfolioExcel(data?.abs_Amount?.actual_value),
            excelCurrValue: portfolioExcel(data?.curr_Amount?.actual_value),
            excelBenchXirr: benchMarkData,
            xirr: portfolioExcel(data?.xirr),
          };
        };
        const getSubAssetsData = ({ data, currentObj }) => {
          return {
            ...data,
            subAssetTotalId: currentObj.investmentVehicleId,
            excelAssetClass: `Total ${data.subAssetClass}`,
            excelAbsAmount: portfolioExcel(data?.amount?.actual_value),
            secondary: true,
            excelBenchXirr: "",
            xirr: portfolioExcel(data?.xirr),
          };
        };

        if (!acc[curr.assetClass]) {
          const assetsTotalData = overallData?.find(
            (overall) => overall.assetClass === curr.assetClass,
          );
          acc[curr.assetClass] = [
            {
              ...getCurrentData({ data: curr, benchMarkData }),
            }, // instrument
            {
              ...getSubAssetsData({ data: subAssetData, currentObj: curr }),
            }, // sub asset total
            {
              excelAssetClass: `Total - ${curr.assetClass}`,
              excelAbsAmount: portfolioExcel(
                Number(assetsTotalData?.amount?.actual_value || 0),
              ),
              xirr: portfolioExcel(Number(assetsTotalData?.xirr || 0)),
              excelBenchXirr: benchMarkData,
              tertiary: true,
            }, // asset total
          ];
        } else {
          const idx = acc[curr.assetClass].findIndex(
            (d) => d.subAssetTotalId === curr.investmentVehicleId,
          );
          if (idx === -1) {
            acc[curr.assetClass].splice(
              acc[curr.assetClass].length - 1,
              0,
              {
                ...getCurrentData({ data: curr, benchMarkData }),
              },
              {
                ...getSubAssetsData({ data: subAssetData, currentObj: curr }),
              }, // sub asset total
            );
          } else {
            acc[curr.assetClass].splice(
              // idx - 1
              idx,
              0,
              {
                ...getCurrentData({ data: curr, benchMarkData }),
              },
            );
          }
        }
      }
    }

    /*
  For with and without holdings data we arent passing different payload, so the data which we are recieving is same for both type of holdings
  1. So for with holding , we will check withHoldings flag is true or false , here it should be true
  2. for not with holding , we will not check above flag and we will show all the instruments
  */
    if (withHoldings) curr.withholdings && reduceExcelData({ acc, curr });
    else reduceExcelData({ acc, curr });

    return acc;
  }, {});

  const totalData = overallPerformanceExcelLastData({ overallData, benchXirr });

  let excelData = {};

  // Check asset class order from overall Data and and add asset classses in order
  if (Object.keys(newData).length) {
    newData.totalData = [totalData, { isBlankRow: true }];
    for (let i = 1; i < overallData?.length; i++) {
      const assetClass = overallData[i].assetClass;
      if (newData[assetClass]) excelData[assetClass] = newData[assetClass];
    }
    if (Object.keys(excelData)?.length) excelData.totalData = newData.totalData;
  }

  //  return newData;
  return excelData;
};

export function getPerformanceExcelFormattedData({ data }) {
  const newData = data?.flatMap((assets) => {
    const asset = { ...assets };
    delete asset.excelAssetData;

    const subAssetData = assets.excelAssetData?.flatMap((subA) => {
      const subAsset = { ...subA };
      delete subAsset.excelInstruments;

      return [subAsset, ...subA.excelInstruments];
    });

    return [asset, ...subAssetData];
  });
  return newData;
}

export const mergeGivenCells = ({ style }) => {
  const from = style.mergeCell?.from || 1;
  const to = style.mergeCell?.to || 1;
  const addRowCount = style.mergeCell?.addRowCount || 0;
  return { from, to, addRowCount };
};

export const getDisplayClms = ({ sourceArr, refArr }) => {
  //let arr = [...sourceArr].filter((column, index) => {
  let arr = [...sourceArr].filter((column, index) => {
    const refElement = refArr?.find((elem) => elem.id === column.id);
    return refElement ? refElement.checked : false;
  });
  const aobj = {
    label: "",
    key: "",
    sortable: false,
    id: 25,
  };
  arr.splice(1, 0, aobj);

  return arr;
};

export const formatDate = ({ date }) => {
  return (
    date?.getFullYear() +
    "-" +
    padNumber(date?.getMonth() + 1) +
    "-" +
    padNumber(date?.getDate())
  );
};

export const getDateYYMMDD = (data) => {
  if (data && data !== "-") {
    let dateNew = data?.split("/");
    return `${dateNew[2]}-${dateNew[1]}-${dateNew[0]}`;
  }
  return "-";
};

export const getTaxData = ({ data }) => {
  if (data.ledger_Type)
    return {
      quantity: data.quantity,
      buyPrice: data.buyPrice,
      gfPrice: data.gfPrice,
      sellPrice: data.sellPrice,
      sellValue: data.sellValue,
      sttSell: data.sttSell,
      sellDate: getDateYYMMDD(data.sellDate),
    };
  return {
    quantity: data.redemptionUnits,
    buyPrice: data.unitCost,
    gfPrice: data.naVason31012018,
    sellPrice: data.redemptionPrice,
    sellValue: data.redemptionValue,
    sttSell: data.sttRedemption,
    sellDate: getDateYYMMDD(data.redemptionDate),
  };
};

export const getGLValue = ({ data }) => {
  const { ledger_Type } = data;

  const type = !ledger_Type ? "mutualFunds" : ledger_Type;

  switch (type) {
    case "Derivatives":
      return data.taxableGL;
    case "mutualFunds":
      return getAddition(
        data?.shortTerm_GL,
        data?.longTermCapitalGainsWithoutIndexation,
      );
    default:
      return data.taxableGainLosswithoutIndexation;
  }
};

export const getTaxAccordionData = ({ data }) => {
  return {
    ...data,
    amount: data?.amount,
    displayName: data?.displayName,
    displayID: data?.displayID,
    ledger_Type: data?.ledger_Type,
    longTerm_GL:
      data.longTerm_GL !== undefined
        ? data?.longTerm_GL
        : data?.longTermCapitalGainsWithoutIndexation,
    parentDisplayID: data?.parentDisplayID,
    longTermCapitalGainsWithoutIndexation:
      data.longTermCapitalGainsWithoutIndexation,
    quantity: data.quantity,
    shortTerm_GL: data.shortTerm_GL === null ? "0" : data.shortTerm_GL,
  };
};

export const getTaxTableData = ({ data }) => {
  return {
    ...data,
    longTermCapitalGainsWithIndexation: data.longTermCapitalGainsWithIndexation
      ? data.longTermCapitalGainsWithIndexation
      : data.taxableGLWithIndexation
        ? data.taxableGLWithIndexation
        : "0",
    shortTerm_GL: data.shortTerm_GL || "0",
    buyDate: getDateYYMMDD(data.buyDate),
    dividendDate: getDateYYMMDD(data.dividendDate),
    ...getTaxData({ data: data }),
    longTermCapitalGainsWithoutIndexation: getGLValue({
      data: data,
    }),
  };
};

export const getUnrealisedFolioData = ({ unrealisedData }) => {
  // from input data we have to make data in below format

  // {
  //   parentID : "0",
  //   ...itsdata,
  //   subData :{
  //     firstChild : [{.. , isSecondChild: true} , {..}],
  //     secondChild :[{.. , isSecondChild: true} , {..}],
  //     ...andsoon,
  //   }
  // },
  // {
  //   parentID : "0",
  // }

  const folioData = [];

  //1.From the initially available data, separate the data into categories: which ones are 'superParent', which ones are 'parent', and which ones are 'child'
  const newReduced = [...unrealisedData].reduce(
    (acc, curr) => {
      let accData = { ...acc };

      const { parentID, isFolio } = curr;

      const dataType =
        parentID === "0" ? "superParent" : isFolio === "1" ? "parent" : "child";

      if (dataType === "superParent") accData.superParent.push({ ...curr });
      else if (dataType === "parent") accData.parent.push({ ...curr });
      else accData.childData.push({ ...curr });

      return accData;
    },
    {
      superParent: [],
      parent: [],
      childData: [],
    },
  );

  // 2. Data Grouping , Each instrument should be grouped according to which parent folio it belongs to and which folio it should go into next.
  // cases : 1. A single folio number can appear under multiple asset classes. For each asset class where the folio number exists,
  //            the API will return separate objects for that folio, along with the corresponding asset class ID.
  //         2. A single folio can contain multiple parent instruments, and each parent instrument can have multiple child instruments.

  newReduced.superParent?.forEach((supParent) => {
    const subData = newReduced.parent?.reduce((acc, curr) => {
      let sub = { ...acc };
      // parent instrument id and super parent (folios) instrument id are same , but as we know one folio can appear in different asset classes and
      // those many objects of those folios with different asset class ids and sub asset class id are available, then for limiting that folio for one asset class and
      // one sub asset class we have to check the asset class id and sub asset class id
      if (
        curr.instrumentID === supParent.instrumentID &&
        curr.assetClassId === supParent.assetClassId &&
        curr.subAssetClassId === supParent.subAssetClassId
      ) {
        sub = {
          ...sub,
          [curr.parentID]: [
            { ...curr, isSecondChild: true },
            ...newReduced.childData?.filter(
              (child) =>
                child.instrumentID === curr.parentID &&
                child.parentID === curr.instrumentID,
            ),
            // childs instrument id and parents parent id are same using this logic we assign the child for particular parent
          ],
        };
      }

      return sub;
    }, {});

    folioData.push({ ...supParent, subData });
  });

  // return Object.values({ ...reducedData.mainData });
  return folioData;
};

export const performanceOverallExcelStyle = ({ worksheet, data }) => {
  const textClms = { vertical: "bottom", horizontal: "left", wrapText: true };
  const numClms = { vertical: "bottom", horizontal: "right", wrapText: true };

  const clms = {
    1: textClms,
    2: textClms,
    3: textClms,
    4: numClms,
    5: numClms,
    6: numClms,
    7: numClms,
  };

  worksheet.eachRow(function (row, rowNumber) {
    if (rowNumber > 8) {
      row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
        row.getCell(colNumber).border = {
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
        };

        // style table body only except grand total row
        if (rowNumber > 9 && rowNumber <= data.length + 7) {
          row.getCell(colNumber).alignment = clms[colNumber];
        } else {
          row.getCell(colNumber).alignment = {
            ...row.getCell(colNumber).alignment,
            wrapText: true,
          };
        }
        if (rowNumber === data.length + 9) {
          row.getCell(colNumber).border = {
            bottom: {
              style: "thin",
            },
            left: {
              style: "thin",
            },
          };
        }
        if (data[rowNumber - 10]?.primary) {
          row.getCell(colNumber).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FFFE08A",
              // rosegold colorof primary data
            },
          };
        }
        if (data[rowNumber - 10]?.secondary) {
          row.getCell(colNumber).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FF95B3D7",
              // rosegold colorof primary data
            },
          };
        }
        if (data[rowNumber - 10]?.tertiary) {
          row.getCell(colNumber).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FFCCA75E",
              // rosegold colorof primary data
            },
          };
        }
      });

      if (rowNumber > 9) {
        const dataIndex = rowNumber - 10;
        const excelStyle = data[dataIndex].excelStyle;
        const excelStyleArr = data[dataIndex].excelStyleArr;

        function styleCell({ mergeCell, font, alignment, fill }) {
          const { from, to, addRowCount } = mergeCell;

          function applyStyle({ type, data }) {
            worksheet.getCell(rowNumber, from)[type] = data;
          }

          worksheet.mergeCells(rowNumber, from, rowNumber + addRowCount, to);
          font && applyStyle({ type: "font", data: font });
          alignment &&
            applyStyle({
              type: "alignment",
              data: alignment,
            });
          fill && applyStyle({ type: "fill", data: fill });
        }
        if (excelStyle) {
          styleCell({
            ...excelStyle,
            mergeCell: mergeGivenCells({
              style: excelStyle,
            }),
          });
        } else if (excelStyleArr) {
          excelStyleArr?.forEach(({ idx, ...rest }, index) => {
            styleCell({ ...rest });
          });
        }
      }
    }
  });
};

export const xlDetailsStyle = {
  font: {
    bold: true,
  },
  alignment: {
    vertical: "middle",
    horizontal: "right",
  },
};

export const unrealisedFolioExcelStyle = ({ worksheet, data }) => {
  worksheet.eachRow(function (row, rowNumber) {
    if (rowNumber > 8) {
      row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
        row.getCell(colNumber).border = {
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
        };
        row.getCell(colNumber).alignment = {
          ...row.getCell(colNumber).alignment,
          wrapText: true,
        };
        if (typeof row.getCell(colNumber).value === "number") {
          row.getCell(colNumber).alignment = {
            horizontal: "right",
            //  wrapText:true,
            shrinkToFit: true,
          };
        }
        if (row.getCell(colNumber).value === "-")
          row.getCell(colNumber).alignment = {
            horizontal: "right",
          };

        if (rowNumber === data.length + 9) {
          row.getCell(colNumber).border = {
            bottom: {
              style: "thin",
            },
            left: {
              style: "thin",
            },
          };
        }
        if (data[rowNumber - 10]?.primary) {
          row.getCell(colNumber).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FFFE08A",
              // rosegold colorof primary data
            },
          };
          row.getCell(colNumber).font = {
            bold: true,
          };
        }
        if (data[rowNumber - 10]?.mainPrimary) {
          row.getCell(colNumber).fill = goldenFill;
          row.getCell(colNumber).font = {
            bold: true,
          };
        }
      });
    }
  });
};

export const overallPerformanceExcelLastData = ({ overallData, benchXirr }) => {
  const excelWhiteColor = { argb: "FFFFFFFF" };
  const totalDataFill = {
    type: "pattern",
    pattern: "solid",
    fgColor: {
      argb: "FF366092",
      // rosegold colorof primary data
    },
  };

  const grandTotalDataStyle = {
    mergeCell: {
      from: 5,
      to: 5,
      addRowCount: 1,
    },
    font: {
      size: 11,
      color: excelWhiteColor,
    },
    alignment: {
      vertical: "middle",
      horizontal: "right",
    },
    fill: { ...totalDataFill },
  };

  const overalTotal = overallData?.find(
    (overall) => overall.assetClass === "Overall",
  );

  const totalData = {
    excelAssetClass: "GRAND TOTAL - PORTFOLIO",
    excelAbsAmount: portfolioExcel(overalTotal?.amount?.actual_value || 0),
    xirr: portfolioExcel(overalTotal?.xirr || 0),
    excelBenchXirr: portfolioExcel(benchXirr),
    excelStyleArr: [
      {
        mergeCell: { from: 1, to: 4, addRowCount: 1 },
        font: { size: 11, color: excelWhiteColor },
        fill: { ...totalDataFill },
        alignment: { vertical: "middle", horizontal: "center" },
        idx: 0,
      },
      { ...grandTotalDataStyle, idx: 2 },
      {
        ...grandTotalDataStyle,
        mergeCell: {
          from: 6,
          to: 6,
          addRowCount: 1,
        },
        idx: 3,
      },
      {
        ...grandTotalDataStyle,
        mergeCell: {
          from: 7,
          to: 7,
          addRowCount: 1,
        },
        idx: 4,
      },
    ],
  };

  return totalData;
};

export const getPerfOverallExcelPercentage = (data, row, key) => {
  return typeof data === "number" ? getLimitPerExcelPerf(data) : "";
};

export const getTaxPDFDate = ({ data }) => {
  const { date, month, year } = data;
  return `${year}-${month}-${date}T00:00:00`;
};

export const getFolioBooleanValue = ({ isFolio }) => {
  if (isFolio) return String(isFolio);
  else return "0";
};

export const devideUGLSubAssetClass = (data) => {
  const updatedData = {
    folioData: {},
    nonFolioData: {},
    folioKeys: {},
    nonFolioKeys: {},
    folios: [],
  };
  Object.entries(data)?.forEach((classes) => {
    classes[1].forEach((subAsset) => {
      const assetClass = String(classes[0]);
      if (subAsset.isFolio) {
        const folioClass = updatedData.folioData[assetClass];

        if (folioClass) {
          updatedData.folioData[assetClass] = [...folioClass, subAsset.classID];
        } else {
          updatedData.folioData[assetClass] = [subAsset.classID];
          updatedData.folioKeys[assetClass] = [];
        }

        updatedData.folios.push(subAsset.classID);
      } else {
        const nonFolioClass = updatedData.nonFolioData[assetClass];
        if (nonFolioClass) {
          updatedData.nonFolioData[assetClass] = [
            ...nonFolioClass,
            subAsset.classID,
          ];
        } else {
          updatedData.nonFolioData[assetClass] = [subAsset.classID];
          updatedData.nonFolioKeys[assetClass] = [];
        }
      }
    });
  });
  return updatedData;
};

export const getExportUGLData = ({ data, mainData, subData }) => {
  const output = [];

  const getPrimaryData = ({ item }) => {
    return {
      instrumentName: item.instrumentName || "",
      investmentValue: item.investmentValue || 0,
      currentValue: item.currentValue || 0,
      unrealised_GL: item.unrealised_GL || 0,
      assetClass: item.assetClass,
      subAssetClass: item.subAssetClass,
    };
  };

  data.forEach((item) => {
    // Push the main name

    output.push({
      ...getPrimaryData({ item }),
      ...mainData,
    });

    // Iterate through all keys in subData
    const subArrays = Object.values(item.subData);

    subArrays?.flat()?.forEach((subArray) => {
      output.push(
        subArray.isSecondChild
          ? {
              ...getPrimaryData({ item: subArray }),
              primary: subArray.isSecondChild,
              ...subData,
            }
          : { ...subArray },
      );
    });
  });

  return output;
};

export const getAllExportData = ({ folioInstrument, nonFolioInstrument }) => {
  let folioData = [];
  const nonFolioData = [];

  const outputExcelData = {
    folioData: [],
    nonFolioData: [],
  };

  const getParents = ({ data }) => {
    return data?.filter((item) => {
      return item.parentID === "0";
    });
  };

  // get seprate folio and non-folio data

  folioData = getUnrealisedFolioData({
    unrealisedData: Object.values(folioInstrument).flat(),
  });

  const flatNonFolioData = [...Object.values(nonFolioInstrument)?.flat()] || [];
  getParents({ data: flatNonFolioData })?.forEach((item) => {
    nonFolioData.push({
      ...item,
      primary: true,
      subData: {
        data: flatNonFolioData?.filter(
          (itemChild) =>
            itemChild.parentID === item.instrumentID &&
            itemChild.isFolio === "0",
        ),
      },
      // childs isFolio key should be "0" and childs parentId and parents instrument ids are same
    });
  });

  // format the data as array of objects in required order and in groups
  outputExcelData.nonFolioData = getExportUGLData({
    data: nonFolioData,
    mainData: { primary: true },
    subData: { childata: true },
  });

  outputExcelData.folioData = getExportUGLData({
    data: folioData,
    mainData: {
      mainPrimary: true,
      cellStyles: {
        backgroundColor: "#cca75e",
        fontWeight: 600,
      },
    },
    subData: {
      cellStyles: {
        fontWeight: 600,
      },
    },
  });

  return outputExcelData;

  //let folioParentInstruments = getParents({ data: nonFolioInstrument });
};

export const printAllExcelUGL = ({
  sheetName,
  filter,
  columns,
  exportMetaData,
  exportDetails,
  getData,
  userData,
  asOfDate,
  isInceptionData,
}) => {
  const excelProps = {
    sheetname: sheetName,
    customNameWithTime: unrealisedName(
      filter.selectedMember,
      filter.selectedAccount,
    ),
    columns: allExcelClms?.concat(columns),
    data: Object.values(exportMetaData)?.flat(),
    reportDetails: {
      relatioshipManager: exportDetails?.find((item) => item.role === "RM")
        ?.name,
      serviceManager: exportDetails?.find((item) => item.role === "CXO")?.name,
      date: getPrintDate(asOfDate),
      clientName:
        getData === "fam" ? userData?.family_name : userData?.full_name,
    },
    excelName: getUGLFileName({
      reportName: sheetName,
      selectedMember: filter.selectedMember,
      selectedAccount: filter.selectedAccount,
      isInceptionData,
    }),
    customExcelTableStyle: ({ worksheet, data }) =>
      unrealisedFolioExcelStyle({ worksheet, data }),
    linkText: {
      text: excelPdfDisclaimerLink.text,
    },
  };
  exportExcel(excelProps);
};

export function getTaxReportFileName({ name }) {
  return `Nuvama Tax Report - ${name} - ${getCurrentDate()}_${getCurrentTime()}`;
}

export function getTaxPdfFileMeta({ account, data }) {
  let file = new Blob([data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(file);

  const fileName = getTaxReportFileName({
    name: account?.accountName,
  });

  return { url, fileName };
}
export function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}

export const getUGLFileName = ({
  reportName = UGLReportName,
  selectedMember,
  selectedAccount,
  isInceptionData,
}) => {
  return `${reportName} - ${unrealisedName(
    selectedMember,
    selectedAccount,
  )} - ${getCurrentDate()} - ${aquisitionValue[isInceptionData.appliedValue]}`;
};

export const getReportDetails = (exportDetails, userData, isFam) => {
  return {
    relatioshipManager: exportDetails?.find((item) => item.role === "RM")?.name,
    serviceManager: exportDetails?.find((item) => item.role === "CXO")?.name,
    clientName: isFam ? userData?.family_name : userData?.full_name,
  };
};

export function getReportType(filteredMember, userData) {
  // filteredMember is set at the time of login and when we change the global filter from select nuvama
  // if filteredMember.selectedMember is not "All" then we use current selected users data and users global/offshore value
  // else we choose familyLevel value
  // isoffshore === 2 then combined value will be shown on UI else if === 0 then only domestic else if === 1 then global
  const member = filteredMember.selectedMember;
  return member !== "All" ? member.isoffshore : userData.isoffshorefamily;
}

export function getUsersOffshoreValue({ data }) {
  const userData = data || UserStore.userData;

  const isFamily =
    UserStore.getData === "fam" && getDecodedToken()?.user_type !== "manager";

  const { isoffshore = 0, isoffshorefamily = 0 } = userData ? userData : {};

  const offshoreKey = isFamily ? isoffshorefamily : isoffshore;

  return offshoreValues[offshoreKey];
}

export function getOffshoreData() {
  const isOffshoreOnly = getUsersOffshoreValue({}) === OFFSHORE;
  const navigateTo = !isOffshoreOnly ? `/${homePageRoute}` : "/portfolio";
  return { isOffshoreOnly, navigateTo };
}

export function getUserDataForAPIs({ userData, getData }) {
  const familyId = userData.family_id || getCookie("famid");
  const userId = userData.user_id || getCookie("userid");
  const { user_type, primary } = getDecodedToken();

  const isOffshoreOnly = getUsersOffshoreValue({}) === OFFSHORE;

  const resourceId = {};
  const resourceApi = {};
  if (getData === "fam") {
    resourceApi.resourceApiPrefix = `families/${familyId}`;
    resourceId.familyid = familyId;
  } else {
    resourceApi.resourceApiPrefix = `clients/${userId}`;
    resourceId.userid = userId;
  }

  return {
    familyId,
    userId,
    user_type,
    primary,
    isOffshoreOnly,
    resourceId,
    resourceApi,
  };
}

export function isOffshoreInvestment() {
  const presentInvestment = getUsersOffshoreValue({});

  return presentInvestment === OFFSHORE || presentInvestment === COMBINED;
}

export function isOffshoretabVisible({ isPrimaryUser, userData }) {
  const loginType = {
    employee: true,
    customer: true,
  };

  function isOffshorePresent({ data }) {
    return data === OFFSHORE || data === COMBINED;
  }

  const { isoffshore = 0, isoffshorefamily = 0 } = userData ? userData : {};

  const offshoreKey =
    loginType[getDecodedToken()?.user_type] && isPrimaryUser
      ? isoffshorefamily
      : isoffshore;

  return isOffshorePresent({ data: offshoreValues[offshoreKey] });
}

export function getPath({ location }) {
  const pathArray = location?.pathname?.split("/");
  const currency = location?.state?.currency;

  return {
    path: pathArray[2] || "",
    currency: currency || "",
  };
}

export function getSubAssetTabs({ data }) {
  let allAssetsData = data.map((eachData) => {
    let subAssetDetails = eachData.instrumentVehiclesList.map(
      (eachVehicleData) => {
        return {
          id: eachVehicleData.id,
          subAssetName: eachVehicleData.assetClass.name,
          subAssetData: [
            {
              assetClassId: eachData.id,
              vehicleId: eachVehicleData.id,
              assetClassData: eachData,
              vehicleData: eachVehicleData,
            },
          ],
        };
      },
    );

    return {
      assetId: eachData.id,
      assetName: eachData.assetClass.name,
      allSubAssetDetails: subAssetDetails,
    };
  });

  return allAssetsData;
}

export function getOffshoreSubAssetTabs({ data }) {
  let allAssetsData = data.map((eachData) => {
    let subAssetDetails = eachData.instrumentVehiclesList.map(
      (eachVehicleData) => {
        return {
          id: eachVehicleData.id,
          subAssetName: eachVehicleData.assetClass.name,
          subAssetData: {
            assetClassId: eachData.id,
            vehicleId: eachVehicleData.id,
            assetClassData: eachData,
            vehicleData: eachVehicleData,
          },
        };
      },
    );

    return {
      assetId: eachData.id,
      assetName: eachData.assetClass.name,
      allSubAssetDetails: subAssetDetails,
    };
  });

  return allAssetsData;
}

export function getSubAssetOffshoreReportName({ getData, userData }) {
  const famName =
    getData === "fam" ? userData?.family_name : userData?.full_name;
  return `Global Portfolio Summary - ${famName}`;
}

export function getSubAssetCurrencyData({
  currencyData,
  assetClassTabs,
  currency,
  allAssetClassData,
}) {
  const subAssetData = currencyData?.map((data) => {
    if (data.currency === currency)
      return {
        ...data,
        [`${data.currency}Data`]: assetClassTabs,
        allAssetClassData,
      };
    else return { ...data };
  });

  return subAssetData;
}

export function getArryIndex({ arr, keyName, value }) {
  const index = arr.findIndex((data) => {
    return data[keyName] === value;
  });

  return index;
}

export function getOffshoreTabs({ data, assetClassId, vehicleId }) {
  const localArray =
    data[data?.length - 1]?.assetId === 0
      ? [...data].slice(0, data?.length - 1)
      : [...data];

  let selectedAssetClassData = null;
  let subAssetClassTabs = null;
  let selectedSubAssetData = null;
  const assetData = data?.find((arr) => arr.assetId == assetClassId);
  if (assetData) {
    selectedAssetClassData = assetData;
    subAssetClassTabs = assetData.allSubAssetDetails;
    const subAssetData = assetData?.allSubAssetDetails?.find(
      (eachData) => eachData?.id == vehicleId,
    );
    if (subAssetData) {
      selectedSubAssetData = subAssetData;
    } else {
      selectedSubAssetData = assetData.allSubAssetDetails[0];
    }
  } else {
    selectedAssetClassData = data[0];
    subAssetClassTabs = data[0].allSubAssetDetails;
    selectedSubAssetData = data[0].allSubAssetDetails[0];
  }

  return {
    assetClassTabs: localArray,
    subAssetClassTabs,
    selectedAssetClassData,
    selectedSubAssetData,
  };
}

export function getOffshoreInstrumentSheetName({ selectedInstrument }) {
  return `${removeSymbol(
    selectedInstrument?.vehicleData?.assetClass?.name,
  )} Instrument Summary`;
}

const transactionDateCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="transaction_date_cell" style={{ minWidth: "423px" }}>
      {/* {getDisplayDate(data.transaction_date)} */}
      {`${getDisplayDate(data)}`}
    </p>
  );
};

const qtyCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {commaSeperated(rowData[key])}
    </p>
  );
};

const priceCellRenderer = (data, rowData, key, currency) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {displayAmountWithCurrency(rowData[key], currency)}
    </p>
  );
};

const tvaCellRenderer2 = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {numWithUnit(rowData[key]?.value, rowData[key]?.value_type)}
    </p>
  );
};

const infinityirrCellRenderer = (data, rowData, key, index) => {
  return (
    <p
      className={`irr_cell ${
        rowData.type === "Corpus Out" || rowData.type === "SOLD"
          ? "red_text"
          : ""
      }`}
    >
      {rowData?.type?.toUpperCase()}
    </p>
  );
};

export const fileColumns = [
  {
    header: "Instrument Name",
    label: "Instrument Name",
    key: "instrument_name",
    cellRendererPdf: (data, row, key) => data,
  },
  {
    header: "Inception Date ",
    label: "Inception Date ",
    key: "inceptiondate",
    isDate: true,
    base: "-",
    cellRendererExcel: (data, row, key) =>
      getExcelDate2(row.actualWholeObject.inceptiondate, "-"),
    cellRendererPdf: (data, row, key) =>
      getExcelDate(row.actualWholeObject.inceptiondate),
  },
  {
    header: "Qty",
    label: "Qty",
    key: "qty",
    cellRendererPdf: (data, row, key) => {
      return showDashIfZero(row?.actualWholeObject?.instrument?.quantity);
    },
  },
  {
    header: "Commitment Value",
    label: "Commitment Value",
    key: "data_com_value",
    cellRendererPdf: (data, row, key) => {
      const commValue =
        row.actualWholeObject.investmentreturn.commitment_val?.amount
          ?.actual_value || "-";
      return lakhData(commValue);
    },
  },
  {
    header: "Avg Buy Price",
    label: "Avg Buy Price",
    key: "Avg_buy_price",
    cellRendererPdf: (data, row, key) => data,
  },
  {
    header: "CMP",
    label: "CMP",
    key: "cmp",
    cellRendererPdf: (data, row, key) => data,
  },
  {
    header: "Inv Value",
    label: "Inv Value",
    key: "data_Inv_Value",
    cellRendererPdf: (data, row, key) => lakhData(data),
  },
  {
    header: "Current Value",
    label: "Current Value",
    key: "data_Curr_Value",
    cellRendererPdf: (data, row, key) => lakhData(data),
  },
  {
    header: "As on Date",
    label: "As on Date",
    key: "as_on_date",
    cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
    cellRendererPdf: (data, row, key) => getExcelDate(data),
  },
  {
    header: "Par Value",
    label: "Par Value",
    key: "data_Par_Value",
    cellRendererPdf: (data, row, key) => lakhData(data),
  },
  {
    header: "Principal payback",
    label: "Principal payback",
    key: "data_Principle_Amt",
    cellRendererPdf: (data, row, key) => lakhData(data),
  },
  {
    header: "Int/Div/Other",
    label: "Int/Div/Other",
    key: "data_Int_Div",
    cellRendererPdf: (data, row, key) => lakhData(data),
  },
  {
    header: "Unrealised Gain",
    label: "Unrealised Gain",
    key: "data_Unre_Gain",
    cellRendererPdf: (data, row, key) => lakhData(data),
  },
  {
    header: "Unrealised(%)",
    label: "Unrealised(%)",
    key: "unrealised_percentage",
    cellRendererPdf: (data, row, key) => data,
  },
  {
    header: "Realised Gain",
    label: "Realised Gain",
    key: "data_Real_Gai",
    sortable: true,
    cellRendererPdf: (data, row, key) => lakhData(data),
  },
  {
    header: "IRR(%)",
    label: "IRR(%)",
    key: "irr",
    sortable: true,
    cellRendererPdf: (data, row, key) => data,
  },
];

export function getOffshoreTransactionColumns({ currency }) {
  const transactionColumns = [
    {
      label: "Transaction Date",
      key: "transaction_date",
      sortable: true,
      keyConfig: {
        clmName: "transaction_date",
        keysObj: { key1: "transaction_date" },
        keyLevel: 1,
        type: "date",
        dateFormat: "ymd",
      },
      cellRenderer: transactionDateCellRenderer,
    },
    {
      label: "Transaction Type",
      key: "type",
      sortable: true,
      keyConfig: {
        clmName: "type",
        keysObj: { key1: "type" },
        keyLevel: 1,
        type: "strings",
      },
      cellRenderer: infinityirrCellRenderer,
    },
    {
      label: "Qty",
      key: "quantity",
      sortable: true,
      keyConfig: {
        clmName: "quantity",
        keysObj: { key1: "quantity" },
        keyLevel: 1,
        type: "numbers",
      },
      cellRenderer: qtyCellRenderer,
    },
    {
      label: "Price",
      key: "rate",
      sortable: true,
      keyConfig: {
        clmName: "rate",
        keysObj: { key1: "rate" },
        keyLevel: 1,
        type: "numbers",
      },
      cellRenderer: (data, rowData, key) =>
        priceCellRenderer(data, rowData, key, currency),
    },
    {
      label: "Transaction Value",
      key: "amount",
      sortable: true,
      keyConfig: {
        clmName: "amount",
        keysObj: { key1: "amount", key2: "actual_value" },
        keyLevel: 2,
        type: "numbers",
      },
      cellRenderer: tvaCellRenderer2,
    },
  ];

  return transactionColumns;
}

export const getWidth = ({ clientWidth }) => {
  if (clientWidth > 990 && clientWidth < 1180) return 201;
  else if (clientWidth > 1181 && clientWidth < 5800) return 221;
};

export const cellRenderer = (_, data, key, clientWidth) => {
  const getFormattedInstrimentName = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "15px",
          gap: "0px",
        }}
      >
        <div className="info_tooptip_icon">
          <p
            style={{ visibility: "hidden", position: "absolute" }}
            id={data?.id}
          >
            {data.instrument_name}
          </p>
          <OverflowingText
            text={data?.instrument_name}
            width={getWidth({ clientWidth })}
            tooltipOnHover={false}
            position="down"
          />
        </div>
        <p
          style={{
            color: "#7E8899",
            fontWeight: "500",
            fontSize: "12px",
            marginTop: "7px",
          }}
        >
          {getDisplayDate(data.actualWholeObject.inceptiondate)} •{" "}
          {data.actualWholeObject.instrument.quantity && (
            <img src={qtybag} alt="" />
          )}
          &nbsp;
          {data?.actualWholeObject?.instrument?.quantity
            ? commaSeperated2(data?.actualWholeObject?.instrument.quantity)
            : "-"}{" "}
          <p>
            {data.actualWholeObject.investmentreturn.commitment_val?.amount
              ?.actual_value &&
              `${"Commitment Value is"} ${commaSeperated2(
                data.actualWholeObject.investmentreturn.commitment_val?.amount
                  ?.value,
              )} ${displayUnit(
                data.actualWholeObject.investmentreturn.commitment_val?.amount
                  ?.value_type,
              )}`}
          </p>
        </p>
      </div>
    );
  };

  const removeDatePortFolio = (data) => {
    let newData = data?.replaceAll("-", "");
    let asOfDate = UserStore.asOfDate?.replaceAll("-", "");
    if (newData && Number(newData) < Number(asOfDate)) {
      return getDisplayDate(data);
    } else return "abc";
  };

  const showLocalString = (amt) => {
    return Number(amt?.replaceAll(",", "") || 0).toLocaleString("hi-IN");
  };

  switch (key) {
    case "instrument_name":
      return (
        <>
          <div className="instrument_name_cell">
            {getFormattedInstrimentName()}
          </div>
        </>
      );
    case "Avg_buy_price":
      return (
        <p className="instrument_name_cell font-roboto">
          {commaSeperated(data.Avg_buy_price)}
        </p>
      );
    case "cmp":
      return (
        <p className="instrument_name_cell font-roboto">
          {commaSeperated(data.cmp)}
        </p>
      );
    case "inv_value":
      return (
        <p className="instrument_name_cell font-roboto">
          {numWithUnit(data?.inv_value, data.invUnit)}
        </p>
      );
    case "current_value":
      return (
        <>
          <div
            className="instrument_name_cell"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className=" font-roboto">
              {numWithUnit(
                data.current_value?.text,
                data.current_value?.textUnit,
                true,
              )}
            </div>
            <div
              className="display_date curr_date"
              style={
                removeDatePortFolio(data.current_value?.subtext || "") === "abc"
                  ? { visibility: "hidden" }
                  : { visibility: "visible" }
              }
            >
              {<>{removeDatePortFolio(data.current_value?.subtext || "")}</>}
            </div>
          </div>
        </>
      );
    case "par_value":
      return (
        <>
          <div
            className="instrument_name_cell"
            style={{ display: "flex", flexDirection: "column", gap: "5px" }}
          >
            <div
              className={
                showLocalString(data.par_value) != 0
                  ? "font-roboto"
                  : "display_date"
              }
            >
              {showLocalString(data.par_value) != 0
                ? numWithUnit(data.par_value, data.par_unit)
                : "-"}
            </div>
            <div className="display_date">
              {showLocalString(data?.principal_paid_amt) != 0
                ? numWithUnit(data.principal_paid_amt, data.pp_unit)
                : "-"}
            </div>
          </div>
        </>
      );

    case "int_div_others":
      return (
        <p className="instrument_name_cell font-roboto">
          {numWithUnit(data.int_div_others, data.intDivUnit)}
        </p>
      );
    case "unrealised_gain":
      return (
        <p className="instrument_name_cell font-roboto">
          {numWithUnit(
            data.unrealised_gain.text,
            data.unrealised_gain.textUnit,
          )}
          &nbsp;
          {!!data?.unrealised_gain?.subtext &&
          Number(data?.unrealised_gain.subtext) < 0 ? (
            <span className="unreal negative">
              {getLimitPer(data?.unrealised_gain?.subtext) + "%"}
            </span>
          ) : (
            <span className="unreal">
              {getLimitPer(data?.unrealised_gain?.subtext) + "%"}
            </span>
          )}
        </p>
      );

    case "realised_Gains":
      return (
        <p className="instrument_name_cell font-roboto">
          {numWithUnit(data.realised_Gains, data.realisedUnit)}
        </p>
      );

    case "irr":
      return (
        <p className="instrument_name_cell font-roboto">
          {!!data?.irr && Number(data?.irr) < 0 ? (
            <span className="negative">{getLimitPer(data?.irr) + "%"}</span>
          ) : (
            <span> {getLimitPer(data?.irr) + "%"}</span>
          )}
        </p>
      );
    default:
      return <p className="instrument_name_cell">{data.invested_value}</p>;
  }
};

export const btnCellRenderer = (_, data, key, getTransactions) => {
  return (
    <p
      style={
        key === "instrument4" &&
        data?.actualWholeObject?.investmentreturn?.commitment_val?.amount
          ?.actual_value
          ? { paddingBottom: "27px" }
          : { paddingBottom: "0px" }
      }
    >
      {" "}
      <button
        onClick={() => {
          getTransactions({ data });
        }}
        className="accordion_right_btn portfolio_button_animation"
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <svg
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.93394 5.64683L5.28634 6L4.93394 6.35317L0.706721 10.5896L1.41 11.2929L6.70289 6L1.41 0.707108L0.706722 1.41039L4.93394 5.64683Z"
              fill="white"
              stroke="#404040"
            />
          </svg>
        </span>
      </button>
    </p>
  );
};

export function getInstrumentColumn({
  cellRenderer,
  btnCellRenderer,
  getTransactions,
  clientWidth,
}) {
  const columns = [
    {
      headerRendererPdf: () => "Instrument Name",
      label: (
        <>
          Instrument Name
          <br /> Inception Date • Qty
        </>
      ),
      key: "instrument_name",
      sortable: true,
      cellRenderer: (_, data, key) => cellRenderer(_, data, key, clientWidth),
      isMultipleSort: true,
      position:
        document.documentElement.clientWidth < 1200
          ? { top: "45px", left: "83px" }
          : { top: "45px", left: "77px" },
      forArrowCheck: "instrument_nameactualWholeObjectinstrument",
      multiSortBox: [
        {
          key: "instrument_name",
          show: "Instrument Name",
        },
        {
          key: "actualWholeObject",
          show: "Inception Date",
        },
        {
          key: "instrument",
          show: "Quantity",
        },
      ],
      pWidth: "110px",
    },
    {
      label: "Avg Buy Price",
      label2: (
        <>
          Avg Buy
          <br />
          <p style={{ textAlign: "end" }}>Price</p>
        </>
      ),
      key: "Avg_buy_price",
      sortable: true,
      cellRenderer: cellRenderer,
    },
    {
      label: "CMP",
      key: "cmp",
      sortable: true,
      cellRenderer: cellRenderer,
    },
    {
      label: "Inv Value",
      key: "inv_value",
      sortable: true,
      cellRendererPdf: (data, row, key) => data.text,
      cellRenderer: cellRenderer,
    },
    {
      label: (
        <span style={{ whiteSpace: "nowrap" }}>
          Current Value
          <br /> As on Date
        </span>
      ),
      key: "current_value",
      sortable: true,
      cellRendererPdf: (data, row, key) => data.text,
      cellRenderer: cellRenderer,
    },
    {
      label: (
        <div style={{ textAlign: "right" }}>
          Par Value
          <br /> Principal payback
        </div>
      ),
      key: "par_value",
      sortable: true,
      cellRenderer: cellRenderer,
      isMultipleSort: true,
      position:
        document.documentElement.clientWidth < 1200
          ? { top: "45px", left: "70px" }
          : { top: "45px", left: "77px" },
      forArrowCheck: "par_valueprincipal_paid_amt",
      multiSortBox: [
        {
          key: "par_value",
          show: "Par Value",
        },
        {
          key: "principal_paid_amt",
          show: "Principal payback",
        },
      ],
    },
    {
      label: (
        <>
          Int/Div/
          <br /> Others
        </>
      ),
      key: "int_div_others",
      sortable: true,
      cellRenderer: cellRenderer,
    },
    {
      label: "Unrealised Gains (%)",
      label2: (
        <>
          Unrealised Gains
          <br />
          <p style={{ textAlign: "end" }}>(%)</p>
        </>
      ),
      key: "unrealised_gain",
      sortable: true,
      cellRendererPdf: (data, row, key) => data.text,
      cellRenderer: cellRenderer,
      classn: "option4Cls",
      optionNum: 4,
      isMultipleSort: true,
      position:
        document.documentElement.clientWidth < 1200
          ? { top: "45px", left: "67px" }
          : { top: "37px", left: "77px" },
      forArrowCheck: "unrealised_gainsubtext",
      multiSortBox: [
        {
          key: "unrealised_gain",
          show: "Unrealised Gains",
        },
        {
          key: "subtext",
          show: "Unrealised Gains (%)",
        },
      ],
      pWidth: "110px",
    },
    {
      label: "Realised Gain",
      label2: (
        <>
          Realised
          <br />
          <p style={{ textAlign: "end" }}>Gain</p>
        </>
      ),
      key: "realised_Gains",
      sortable: true,
      cellRendererPdf: (data, row, key) => data.text,
      cellRenderer: cellRenderer,
    },
    {
      label: "IRR ",
      key: "irr",
      sortable: true,
      cellRenderer: cellRenderer,
    },
    {
      label: "",
      key: "instrument4",
      cellRenderer: (_, data, key, index, total, index2) =>
        btnCellRenderer(_, data, key, getTransactions),
    },
  ];

  return columns;
}

export function getUniqueCurrencies({ data }) {
  const unique = [
    ...new Map(data.map((item) => [item.currency, item])).values(),
  ];

  return unique;
}

export function dataIsArray(data) {
  return Array.isArray(data);
}

export function getAssetsClassTabsData({ data }) {
  let assetClassTabs = [];

  data
    ?.filter((assetClass) => assetClass.isHolding)
    ?.forEach((assetClass) => {
      // Check current asset class from loop is present in assetClassTabs or not

      const idx = assetClassTabs?.findIndex(
        (tabs) => tabs.assetId === assetClass.assetClassId,
      );

      // If asset class is not present then add the asset class and sub asset class in assetClassTabs
      if (idx === -1) {
        assetClassTabs.push({
          assetId: assetClass.assetClassId,
          assetName: assetClass.assetClass,
          allSubAssetDetails: [
            {
              id: assetClass.subAssetClassId,
              subAssetName: assetClass.subAssetClass,
              assetClassId: assetClass.assetClassId,
              vehicleId: assetClass.subAssetClassId,
              assetId: assetClass.assetClassId,
              assetName: assetClass.assetClass,
              currencyWiseData: [{ ...assetClass }],
              currency: assetClass.currency,
            },
          ],
        });
      } else {
        const subAssetIndex = assetClassTabs[
          idx
        ]?.allSubAssetDetails?.findIndex(
          (tabs) => tabs.id === assetClass.subAssetClassId,
        );

        if (subAssetIndex === -1) {
          assetClassTabs[idx]?.allSubAssetDetails.push({
            id: assetClass.subAssetClassId,
            subAssetName: assetClass.subAssetClass,
            assetClassId: assetClass.assetClassId,
            vehicleId: assetClass.subAssetClassId,
            assetId: assetClass.assetClassId,
            assetName: assetClass.assetClass,
            currencyWiseData: [{ ...assetClass }],
            currency: assetClass.currency,
          });
        } else {
          assetClassTabs[idx].allSubAssetDetails[
            subAssetIndex
          ].currencyWiseData.push({ ...assetClass });
        }
      }
    });

  return assetClassTabs;
}

export const getOffshoreSubAssetDataStructure = ({ offshoreTabs }) => {
  const result = offshoreTabs.reduce((acc, item) => {
    const subAssetResult = item.allSubAssetDetails?.reduce(
      (subAcc, subItem) => {
        const currencyData = subItem?.currencyWiseData?.reduce(
          (currencyAcc, currencyItem) => {
            currencyAcc[currencyItem.currency] = {
              ...currencyItem,
            };
            return currencyAcc;
          },
          {},
        );

        subAcc[subItem.id] = {
          //  ...subItem,
          currencyWiseData: currencyData,
        };
        return subAcc;
      },
      {},
    );

    acc[item.assetId] = {
      //...item,
      allSubAssetDetails: subAssetResult,
    };
    return acc;
  }, {});

  return result;
};

export const updateCurrencyData = ({
  structuredData,
  assetClassId,
  vehicleId,
  currency,
  data,
}) => {
  const currencyData =
    structuredData[assetClassId].allSubAssetDetails[vehicleId].currencyWiseData[
      currency
    ];

  structuredData[assetClassId].allSubAssetDetails[vehicleId].currencyWiseData[
    currency
  ] = {
    ...currencyData,
    ...data,
  };

  return structuredData;
};

export const getOffshoreInvestmentReturn = ({ data }) => {
  const details = data.subAssetInvestmentDetails;

  const investmentreturn = {
    as_of_date: details.as_of_date,
    current_value: {
      actual_value: details.curr_actual_amt || "",
      value: details.curr_amt || "",
      value_type: details.curr_amt_type || "",
    },
    total_returns: {
      actual_value: details.total_actual_amt || "",
      value: details.total_amt || "",
      value_type: details.total_amt_type || "",
    },
    irr: details.irr,
    invested_value: {
      actual_value: details.invested_actual_amt || "",
      value: details.invested_amt || "",
      value_type: details.invested_amt_type || "",
    },
    int_div: {
      amount: {
        actual_value: details.intdiv_actual_amt || "",
        value: details.intdiv_amt || "",
        value_type: details.intdiv_amt_type || "",
      },
    },
    unrealised_gain: {
      amount: {
        actual_value: details.unrealised_actual_amt || "",
        value: details.unrealised_amt || "",
        value_type: details.unrealised_amt_type || "",
      },
      percentage: details.percentage_unrealised || "",
    },
    realised_gain: {
      amount: {
        actual_value: details.realised_actual_amt || "",
        value: details.realised_amt || "",
        value_type: details.realised_amt_type || "",
      },
      percentage: details.percentage_realised || "",
    },
  };

  return {
    investmentreturn,
    allocation_percentage: data.allocation?.allocationPercentage,
  };
};

export const getOffshoreSavedData = ({
  data,
  assetClassId,
  vehicleId,
  currency,
}) => {
  const currenciesData =
    data?.[assetClassId]?.allSubAssetDetails?.[vehicleId]?.currencyWiseData?.[
      currency
    ];

  const selectedModifiedVehicleData = currenciesData?.modifiedVehicleData;
  const selectedVehicleData = currenciesData?.vehicleData;

  let savedData = {
    modifiedVehicleData: null,
    vehicleData: null,
  };

  if (selectedModifiedVehicleData) {
    savedData.modifiedVehicleData = [...selectedModifiedVehicleData];
  }
  if (selectedVehicleData) {
    savedData.vehicleData = { ...selectedVehicleData };
  }

  return savedData;
};

export const getPortfolioAssetsReportName = () => {
  const famName =
    UserStore.getData === "fam"
      ? UserStore.userData?.family_name
      : UserStore.userData?.full_name;
  return `Global Portfolio Summary - ${famName}`;
};

export const getPortfolioAssetsReportHeader = ({ currency }) => {
  return `${offshoreAssetClassSheetName} - ${currency}`;
};

export const isPortfolioAssetsDataPresent = ({ dataCheck }) => {
  // If from current value, invested value, unrealised gain amount, realised gain amount and total returns any one of the value is present and it is not zero then we return true
  // else all the mentioned values are 0 then we return false
  if (
    (dataCheck?.current_value?.value &&
      Number(dataCheck?.current_value?.value) !== 0) ||
    (dataCheck?.invested_value?.value &&
      Number(dataCheck?.invested_value?.value) !== 0) ||
    (dataCheck?.unrealised_gain?.amount.value &&
      Number(dataCheck?.unrealised_gain?.amount.value) !== 0) ||
    (dataCheck?.realised_gain?.amount.value &&
      Number(dataCheck?.realised_gain?.amount.value) !== 0) ||
    (dataCheck?.total_returns?.value &&
      Number(dataCheck?.total_returns?.value) !== 0)
  ) {
    return true;
  } else {
    return false;
  }
};

export function getPortfolioAssetsExcelData({ excelData }) {
  let modifiedExcelPdfData = [];

  const getExcelClms = (value) => {
    return getExcelNumData2(value, false, 2);
  };

  excelData?.forEach((assetClass) => {
    modifiedExcelPdfData.push({ ...assetClass, primary: true });
    assetClass.instrumentVehiclesList.forEach((subAssetClass) => {
      let subAssetObj = {
        asset_class: subAssetClass.assetClass.name,
        allocation: getLimitPer(subAssetClass.allocation_percentage),
        curr_value:
          getExcelClms(
            subAssetClass.investmentreturn.current_value.actual_value,
          ) || "-",
        inv_value:
          getExcelClms(
            subAssetClass.investmentreturn.invested_value.actual_value,
          ) || "-",
        int_div: getExcelClms(
          subAssetClass.investmentreturn.int_div.amount.actual_value,
        ),
        unrealised_gain:
          getExcelClms(
            subAssetClass.investmentreturn.unrealised_gain.amount.actual_value,
          ) || "-",
        unrealised_percentage:
          getLimitPer(
            subAssetClass.investmentreturn.unrealised_gain.percentage,
          ) || "-",
        realised_gain:
          getExcelClms(
            subAssetClass.investmentreturn.realised_gain.amount.actual_value,
          ) || "-",
        irr: getLimitPer(subAssetClass.investmentreturn.irr),
      };
      modifiedExcelPdfData.push({ ...subAssetObj });
    });
  });

  return modifiedExcelPdfData;
}

export function isOffshoreTabDataFailed({ apiList }) {
  const apisToCheck = [
    // "getUsersPortfolioReturn",
    // "getUsersReturnsLine",
    "getUsersPortfolioAssetClasses",
    "getUsersSubAssetClasses",
    "getFamilyView",
  ];

  let index = 0;
  apisToCheck?.forEach((apiName) => {
    if (apiList[apiName] !== "failed") {
      index = index + 1;
    }
  });

  // Do not increment index when an API fails.
  // If index !== mentioned API list length then return true (fetch failed), else false (fetch successful)

  return index !== apisToCheck.length;
}

export function isFinancialAssetTabDataFailed({ apiList }) {
  const financialAssetsApi = { ...apiList };
  delete financialAssetsApi.familyPortfolioReturn;
  delete financialAssetsApi.returnsLine;

  let index = 0;

  Object.keys(financialAssetsApi)?.forEach((apiName) => {
    if (financialAssetsApi[apiName] !== "failure") {
      index = index + 1;
    }
  });

  // Do not increment index when an API fails.
  // If index !== mentioned API list length then return true (fetch failed), else false (fetch successful)

  return index !== Object.keys(financialAssetsApi).length;
}

export function formatDateObj({ date, month, year }) {
  const monthMap = {
    January: "01",
    February: "02",
    March: "03",
    April: "04",
    May: "05",
    June: "06",
    July: "07",
    August: "08",
    September: "09",
    October: "10",
    November: "11",
    December: "12",
  };

  const day = String(date).padStart(2, "0");
  const monthNum = monthMap[month];

  return `${year}-${monthNum}-${day}`;
}

export function formatCalenderDate(dateObj) {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // +1 because Jan = 0
  const day = String(dateObj.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function showLogoutConfirmation() {
  return new Promise((resolve) => {
    AuthStore.resolveFn = resolve;
  });
}

export function openSessionExpiredModal() {
  if (!AuthStore.isSessionExpiredFromAPI) {
    AuthStore.setData("isSessionExpiredFromAPI", true);

    // try {
    //   await showLogoutConfirmation();
    //   onSuccess();
    // } catch (e) {
    // }
  }
}

export function closeModalAndContinue() {
  AuthStore.setData("isSessionExpiredFromAPI", false);

  // if (AuthStore.resolveFn) {
  //   AuthStore.resolveFn();
  //   AuthStore.resolveFn = null;
  // }
}

export function formatDateToLocaleDateString({ dateStr }) {
  const date = new Date(dateStr);

  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function getGraphDataInSortedOrder({ data }) {
  let sortedData = [];
  if (data && data.length) {
    sortedData = data?.sort((a, b) => new Date(a?.date) - new Date(b?.date));
  }
  return sortedData;
}

export const calenderSetterTaxReport = (
  changedDate,
  compareWithDate,
  forFromLimitDate,
  minDate,
  selectedFromDate,
  DateType,
  setFromCalender,
  setToCalender,
) => {
  const getTime = (date) => {
    return new Date(date).getTime();
  };

  const changedDateTime = getTime(changedDate);
  // const toDateTime = getTime(compareWithDate);
  const asOfDateTime = getTime(forFromLimitDate);
  const minDateTime = getTime(minDate);
  const fromDateTime = getTime(
    String(selectedFromDate.year) +
      "-" +
      `${
        monthFullNameArr.indexOf(selectedFromDate.month) < 10
          ? "0" + monthFullNameArr.indexOf(selectedFromDate.month)
          : monthFullNameArr.indexOf(selectedFromDate.month)
      }` +
      "-" +
      String(
        `${
          selectedFromDate.date < 10 && selectedFromDate.date?.length === 1
            ? "0" + selectedFromDate.date
            : selectedFromDate.date
        }`,
      ),
  );

  const changeArr = changedDate?.split("-");
  const minArr = minDate?.split("-");
  const maxArr = forFromLimitDate?.split("-");

  if (DateType === "to") {
    if (changedDateTime < fromDateTime) {
      if (changedDateTime < minDateTime) {
        setFromCalender(minDate, minArr);
        setToCalender(minDate, minArr);
        // here change both the dates to minDate
      } else {
        setFromCalender(changedDate, changeArr);
        setToCalender(changedDate, changeArr);
        // change both the dates to newDate
      }
    } else if (changedDateTime > asOfDateTime) {
      // change to date to as of date
      setToCalender(forFromLimitDate, maxArr);
    } else {
      setToCalender(changedDate, changeArr);
      // change to date to new date
    }
  } else {
    // Check if changed from date exceeds the minimum or maximum date limits or not
    let finalChangedDate = null;
    if (changedDateTime > asOfDateTime) {
      // change from date to as of date1
      finalChangedDate = forFromLimitDate;
      setFromCalender(forFromLimitDate, maxArr);
    } else if (changedDateTime < minDateTime) {
      // change from date to min date
      finalChangedDate = minDate;

      setFromCalender(minDate, minArr);
    } else {
      // Valid changed date
      finalChangedDate = changedDate;
      setFromCalender(changedDate, changeArr);
    }

    const finalChangedDateArr = finalChangedDate?.split("-");
    const changedToDate = `${Number(finalChangedDateArr[0]) + 2}-${
      finalChangedDateArr[1]
    }-${finalChangedDateArr[2]}`;
    const changedToDateTime = getTime(changedToDate);
    // Is calculated to date is greater than or equal to as of date then set as of date as to date
    if (asOfDateTime <= changedToDateTime) {
      setToCalender(forFromLimitDate, maxArr);
    } else {
      setToCalender(changedToDate, changedToDate?.split("-"));
    }
  }
};

export const validateTaxReportDate = ({ fromDate, toDate }) => {
  function convertToISODate({ year, month, date }) {
    const monthMapdata = monthMap;
    return `${year}-${monthMapdata[month]}-${date}`;
  }

  function getDatesTime({ dateData }) {
    return new Date(dateData).getTime();
  }

  const twoYearsDateInFormat = convertToISODate({
    year: Number(fromDate.year) + 2,
    month: fromDate.month,
    date: fromDate.date,
  });
  const toDateInFormat = convertToISODate(toDate);

  const twoYearsDateTime = getDatesTime({ dateData: twoYearsDateInFormat });
  const toDateTime = getDatesTime({ dateData: toDateInFormat });

  return toDateTime <= twoYearsDateTime;
};

export function normalizeDate({ dateString }) {
  const [yearData, monthData, dayData] = dateString?.split("-").map(Number);

  const lastDayOfMonth = new Date(yearData, monthData, 0).getDate();

  const validDay = Math.min(dayData, lastDayOfMonth);

  return `${yearData}-${String(monthData).padStart(2, "0")}-${String(
    validDay,
  ).padStart(2, "0")}`;
}

export function getAcquisitionValue({ data }) {
  return data === "Transfer-In Date" ? 0 : 1;
}

export function getDefaultDateType({ data }) {
  return data !== "(Inception)" ? "Transfer-In Date" : "Inception Date";
}

export async function downloadPDFFile({ headerName, fileId, ...rest }) {
  const fileName =
    rest.nameWithoutDateTime !== undefined
      ? rest.nameWithoutDateTime
      : `${rest.name || ""} - ${getCurrentDate()}.pdf`;

  const blob3 = await generateTransactionsReport({
    headerName,
    fileId,
    fileInfoTitle: rest.customFileName ? rest.customFileName : fileName,
    ...rest,
  });

  const url = URL.createObjectURL(blob3);
  const a = document.createElement("a");
  a.href = url;
  a.download = rest.customFileName ? `${rest.customFileName}.pdf` : fileName;
  a.click();
  URL.revokeObjectURL(url);
}
